<template>
  <div>
    <el-row style="display: flex;height: 67px;overflow: auto" ref="menuRow" justify="end">
<!--    <block-select :template-info="templateInfo"  v-if="false" ref="blkSel"></block-select>-->
<!--    <block-select :template-info="templateInfo"  v-if="blockSelectShow&&!homePageManager" ref="blkSel"></block-select>-->
<!--    <el-row>-->
<!--      <el-col :lg="14" v-show="upload_status==1" style="padding-top: 10px">-->
<!--        <docFileUploader v-if="upload_status==1" :use="upload_type" v-bind:after-upload="afterUpload"/>-->
<!--      </el-col>-->
<!--      <el-col :lg="14" v-if="isWork" style="padding-top: 10px">-->
<!--        <docFileUploader ref="workFileUploader" :myPlaceholder="isWork?'工作总结方案':''" :useDiolog="true" v-if="isWork"   :use="'Work'" v-bind:after-upload="afterUpload"/>-->
<!--      </el-col>-->
      <div v-if="isYearMonDay || (templateInfo.type!=null && templateInfo.type.indexOf('table_day')!=-1)" style="margin-top: 9px">
<!--        <div :style="!frameTimeType ? 'width: 425px' : 'width: 345px'">-->
<!--          <el-card shadow="hover" :body-style="{padding:'5px'}">-->
            <el-switch v-if="isNeedTimeSwitch" size="small" v-model="frameTimeType" style="padding-right: 10px"></el-switch>
            <span style="font-size: 14px;color: #606266;font-family: '方正大黑简体';font-weight: bold;">日期：</span>
            <div v-if="!frameTimeType" style="display: inline-block">
              <el-date-picker
                  size="small"
                  v-model="frameYear.startTime"
                  type="date"
                  value-format="YYYY-MM-DD"
                  placeholder="开始"
                  :disabled-date="disabledFrameDayStart"
                  style="width: 140px"
              ></el-date-picker>
              ~
              <el-date-picker
                  size="small"
                  v-model="frameYear.endTime"
                  type="date"
                  value-format="YYYY-MM-DD"
                  placeholder="结束"
                  :disabled-date="disabledFrameDayEnd"
                  style="width: 140px"
              ></el-date-picker>
            </div>
            <el-date-picker
                size="small"
                v-else-if="frameTimeType"
                v-model="frameTimeSpot"
                type="date"
                value-format="YYYY-MM-DD"
                placeholder="请选择"
            ></el-date-picker>
<!--          </el-card>-->
<!--        </div>-->
      </div>
      <div v-if="isYearMonth || (templateInfo.type!=null && (templateInfo.type.indexOf('table_mon')!=-1 || templateInfo.type == 'table_enter_csj'))" style="margin-top: 9px">
<!--        <div :style="!frameTimeType ? 'width: 500px' : 'width: 370px'">-->
<!--          <el-card shadow="hover" :body-style="{padding:'5px'}">-->
            <el-switch v-if="isNeedTimeSwitch" size="small" v-model="frameTimeType" style="padding-right: 10px"></el-switch>
            <span style="font-size: 14px;color: #606266;font-family: '方正大黑简体';font-weight: bold;">日期：</span>
            <div v-if="!frameTimeType" style="display: inline-block">
              <el-date-picker
                  size="small"
                  v-model="frameYear.startTime"
                  type="month"
                  value-format="YYYYMM"
                  placeholder="开始"
                  :disabled-date="disabledFrameMonStart"
                  style="width: 140px"
              ></el-date-picker>
              ~
              <el-date-picker
                  size="small"
                  v-model="frameYear.endTime"
                  type="month"
                  value-format="YYYYMM"
                  placeholder="结束"
                  :disabled-date="disabledFrameMonEnd"
                  style="width: 140px"
              ></el-date-picker>
            </div>
            <el-date-picker
                size="small"
                v-else-if="frameTimeType"
                v-model="frameTimeSpot"
                type="month"
                value-format="YYYYMM"
                placeholder="请选择"
            ></el-date-picker>
<!--          </el-card>-->
<!--        </div>-->
      </div>
      <div v-if="isYear ||(templateInfo.type!=null && templateInfo.type.indexOf('table_year')!=-1)" style="margin-top: 9px">
        <!--          <div :style="!frameTimeType ? 'width: 500px' : 'width: 370px'">-->
        <!--            <el-card shadow="hover" :body-style="{padding:'5px'}">-->
        <el-switch v-if="isNeedTimeSwitch" size="small" v-model="frameTimeType" style="padding-right: 10px"></el-switch>
        <span style="font-size: 14px;color: #606266;font-family: '方正大黑简体';font-weight: bold;">日期：</span>
        <div v-if="!frameTimeType" style="display: inline-block">
          <el-date-picker
              size="small"
              v-model="frameYear.startTime"
              type="year"
              value-format="YYYY"
              placeholder="开始"
              :disabled-date="disabledDateStart"
              style="width: 120px"
          ></el-date-picker>
          ~
          <el-date-picker
              size="small"
              v-model="frameYear.endTime"
              type="year"
              value-format="YYYY"
              placeholder="结束"
              :disabled-date="disabledDateEnd"
              style="width: 120px"
          ></el-date-picker>
        </div>
        <el-date-picker
            size="small"
            v-else-if="frameTimeType"
            v-model="frameTimeSpot"
            type="year"
            value-format="YYYY"
            placeholder="请选择"
        ></el-date-picker>
        <!--            </el-card>-->
        <!--          </div>-->
      </div>
<!--      <yjcg-filter :template-info="templateInfo"  v-if="blockSelectShow"></yjcg-filter>-->
      <div style="margin-top: 12px" v-show="viewDisplay">
        <el-button size="mini" type="primary" @click.stop="assessAdd"
                   v-if="isManager && templateInfo.type == 'table_assess'" >新增
        </el-button>
        <el-popconfirm title="考核指标发布后，各相关单位将会收到通知，是否确认发布？" v-if="isManager && templateInfo.type == 'table_assess'" @confirm="assessRelease">
          <template #reference>
            <el-button size="mini" type="primary">发布</el-button>
          </template>
        </el-popconfirm>
        <input type="file" style="display: none" name="file"  ref="upload" accept=".xls,.xlsx" @change="takeExcelInfo()"/>
        <docFileUploader ref="docFileUploader" style="display: none" :myFiles="myFiles"  :use="'Excel'" v-bind:after-upload="afterUpload"/>
        <docFileUploader ref="workFileUploader" :myPlaceholder="isWork?'工作总结方案':''" :useDiolog="true" v-if="isWork"   :use="'Work'" v-bind:after-upload="afterUpload"/>

        <el-button v-if="iswellGroup" size="mini" type="primary" @click="clickSelectionWell">选井</el-button>
        <!-- 研究成果上报（上传按钮）-->
        <docFileUploader v-if="upload_status==1&&!isWork" :use="upload_type" v-bind:after-upload="afterUpload" />
        <!--数据甄别送审-->
        <el-button size="mini" type="primary" @click.stop="dataScreenSubmit" v-if="dataScreen&&!dataScreenApproval">
          送审
        </el-button>
        <!--数据上传送审-->
        <el-button size="mini" type="primary" @click.stop="uploadSubmit" v-else-if="uploadList&&!dataScreenApproval">
          送审
        </el-button>
        <!--数据反馈送审-->
        <el-button size="mini" type="primary" @click.stop="sendToVerify" v-else-if="!dataScreen&&isSendVerify">
          送审
        </el-button>
        <el-button size="mini" type="primary" @click.stop="verifyDlgVisible = true" v-if="!dataScreen&&doVerify">审核
        </el-button>
        <el-button size="mini" type="primary" @click.stop="assessSchemeverifyDlgVisible = true" v-if="assessSchemeApproval">审核
        </el-button>
        <el-button size="mini" type="primary" @click.stop="verifyDlgVisible = true" v-if="dataScreenApproval">审核
        </el-button>
        <el-button size="mini" type="primary" @click.stop="doUploadApproval" v-if="uploadApproval">审核
        </el-button>
        <el-button size="mini" type="primary" @click="indexDataUpload" v-if="isIndexDataShow&false">数据送审</el-button>
        <el-button size="mini" type="primary" @click="deleteRecordUpload" v-if="isDeleteRecordShow" >删除记录</el-button>

        <el-switch v-model="showDocView" style="margin-top: 0px;margin-left: 10px;margin-right: 12px" v-if="isShowDocReviewSwitch" @change="$refs.tableControl.tableKey++"
                   :active-text="showDocView?'预览窗模式':'弹窗模式'"
        >预览窗
        </el-switch>
<!--        <el-dropdown v-if="showGridCfg && homepage_mgr==null && templateInfo.type!='table_assess'" class="newChartBtn" size="mini" split-button-->
<!--                     type="primary" @click="config" style="margin-right: 12px">表格配置-->
<!--          <template #dropdown>-->
<!--            <el-dropdown-menu class="xxx">-->
<!--              <el-dropdown-item @click="config" icon="el-icon-document">表格配置</el-dropdown-item>-->
<!--              <el-dropdown-item @click="saveConfig" icon="el-icon-document">保存配置</el-dropdown-item>-->
<!--              <el-dropdown-item @click="clickSaveAsConfig" icon="el-icon-copy-document">另存配置</el-dropdown-item>-->
<!--              <el-dropdown-item @click="switchConfig" icon="el-icon-sort">配置切换</el-dropdown-item>-->
<!--              <el-dropdown-item v-if="isManager" @click="clickSaveSystemConfig" icon="el-icon-document">另存系统配置</el-dropdown-item>-->
<!--              <el-dropdown-item v-if="isManager" @click="clickSavepublicConfig" icon="el-icon-document">另存公用配置</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </template>-->
<!--        </el-dropdown>-->
        <el-dropdown v-if="false" class="newChartBtn" size="mini" split-button
                     type="primary" @click="config" style="margin-right: 12px">表格配置
          <template #dropdown>
            <el-dropdown-menu class="xxx">
              <el-dropdown-item @click="config" icon="el-icon-document">表格配置</el-dropdown-item>
              <el-dropdown-item @click="saveConfig" icon="el-icon-document">保存配置</el-dropdown-item>
              <el-dropdown-item @click="clickSaveAsConfig" icon="el-icon-copy-document">另存配置</el-dropdown-item>
              <el-dropdown-item @click="switchConfig" icon="el-icon-sort">配置切换</el-dropdown-item>
              <el-dropdown-item v-if="isManager" @click="clickSaveSystemConfig" icon="el-icon-document">另存系统配置</el-dropdown-item>
              <el-dropdown-item v-if="isManager" @click="clickSavepublicConfig" icon="el-icon-document">另存公用配置</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button size="mini" type="primary" @click.stop="refresh" v-if="false">条件过滤</el-button>
        <el-button v-if="form.pagination&&false" size="mini" type="primary" @click.stop="initGrid()">查询</el-button>
        <el-dropdown v-if="!form.pagination" class="newChartBtn" size="mini" split-button
                     type="primary" @click="initGrid" style="margin-left: 10px;margin-right: 12px">查询
          <template #dropdown>
            <el-dropdown-menu class="xxx">
              <el-dropdown-item @click="initGrid" icon="el-icon-document">查询</el-dropdown-item>
              <el-dropdown-item @click="()=>{pageSize = 99999999;queryGridData(true)}" icon="el-icon-document">查询全部</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button size="mini" type="default" @click.stop="file" v-if="templateInfo.type != 'table_assess' && false" >导出</el-button>
      </div>
      <el-row style="display: flex">
      <div style="margin-top: 12px" v-show="viewDisplay">
        <el-button size="mini" type="default" @click.stop="takeEx"
                   v-if="showuploadtablefileBtn&&templateInfo.type != 'table_assess'" >导入</el-button>
        <el-button size="mini" type="primary" @click.stop="calcData" v-if="showCalcBtn">计算</el-button>


        <el-button size="mini" type="primary" @click="saveEditTabeleData" :disabled="editTableList.length==0"
                   v-if="false&&((showuploadtablefileBtn&&templateInfo.type != 'table_assess'&&isKFBAdmin)||isShowSaveBtn)">保存
        </el-button>
        <span v-if="viewEnterBtn  || showuploadtablefileBtn">
          <el-button size="mini" type="primary" v-if="viewTableControl" @click="enterMode">录入</el-button>
<!--          <el-button size="mini" type="primary" v-else @click="viewTableControl=!viewTableControl">展示</el-button>-->
          <el-button size="mini" type="primary" v-else-if="false" @click="viewTableControl=!viewTableControl">展示</el-button>
        </span>
      </div>
      <div v-if="!viewTableControl" style="margin-top: 12px">
        <el-button size="mini" type="default" @click="addTableData">添加</el-button>
        <el-button size="mini" type="default" @click="deleteTableData">删除</el-button>
        <el-button size="mini" type="default" @click="resetTableData">清空</el-button>
        <el-button size="mini" type="primary" @click="generateLic">
          <span v-if="$route.name === '6-1'">生成许可</span>
          <span v-else>保存</span>
        </el-button>
      </div>
        <el-button size="mini" type="primary" @click.stop="showPage" style="margin-top: 12px" v-if="$route.name !== '6-1'">显示分页</el-button>
      </el-row>
<!--    </el-row>-->
    </el-row>
    <el-row>
      <el-col :span="showDocView?16:24">
        <tableControl
        ref="tableControl"
        v-show="viewDisplay && viewTableControl"
        :selectable="selecTable"
        :check-selectablefield="checkSelecTableField"
        :template-info="templateInfo"
        :grid-cfg="gridCfg"
        :show-route-in="showDocView"
        v-bind:show-route-out-event="onShowRoute"
        v-bind:select-column-status-changed="onSelectColumnStatusChanged"
    ></tableControl>
        <!--    无限滚动加载动画-->
        <el-progress v-if="isInfinite" :percentage="100"  :indeterminate="true" :duration="1" :show-text="false" />
        <!--    录入数据报表-->
        <el-table :data=addTableDataList v-if="!viewTableControl" border stripe max-height="600px" fit
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  style="margin-top: 50px">
          <el-table-column
              v-for="item in jsons.header"
              :filters="getHeadFilter(item)"
              :filter-method="getHeadFilter(item)!=null?filterHandler:null"
              :key="item.data"
              :prop="item.data"
              :label="item.label">
            <template #default="{row,column,$index}">
              <el-input size="small" class="paperview-input-text" v-model="addTableDataList[$index][item.data]" v-if="item.entryType=='input'" ></el-input>
              <el-input size="small"
                        class="paperview-input-text"
                        v-model="addTableDataList[$index][item.data]"
                        v-if="item.entryType=='number'"
                        type="number"
                        @input="handleInput($event, item, $index)"></el-input>
              <span v-if="item.entryType=='text'">{{addTableDataList[$index][item.data]}}</span>
              <el-select v-model="addTableDataList[$index][item.data]"
                         @focus="getSelectFocus(item.label,$index)"
                         @change="enterSelectChange(item.label,$event,$index)"
                         size="small"
                         filterable
                         v-if="item.entryType=='select'">
                <el-option
                    v-for="item in selectDataList"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
              <el-date-picker
                  v-model="addTableDataList[$index][item.data]"
                  type="date"
                  size="small"
                  value-format="YYYY-MM-DD"
                  style="width: 130px"
                  v-if="item.entryType=='date'"/>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, prev, pager, next,sizes, jumper"
            :total="form.dataNum"
            :page-count="pageCount"
            :current-page="currentPage"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="text-align: right"
            v-if="form.pagination&&viewTableControl"
            v-show="viewDisplay"
        >
        </el-pagination>
      </el-col>
      <el-col :span="8" v-if="showDocView" style="border-left: 1px solid #EBEEF5;">
        <el-card shadow="never" style="border: 0px">
          <iframe id="docShow" v-show="routeImgType=='doc'"
                  onload="this.height=document.body.scrollHeight-64"
                  :src="docShowIframeUrl" width="100%" height="100%" frameborder="0"></iframe>
        <el-image v-show="routeImgType!=='doc'" style="height: calc(100vh - 330px)" :src="routeImgUrl" fit="contain" :preview-src-list="[routeImgUrl]" lazy>
          <template #error>
            <div class="image-slot">
              <el-icon><icon-picture /></el-icon>
            </div>
          </template>
        </el-image>

        </el-card>
      </el-col>
    </el-row>

    <div v-dialogDrag>
      <el-dialog
          v-model="dialogVisible"
          title="表格配置"
          width="800px"
          :before-close="handleClose"
      >
        <el-form ref="form" :model="form" label-width="100px" label-position="left">
          <el-row>
            <el-col :span="24" v-if="isManager">
              <el-form-item label="数据来源" >
                <tree-select :value="form.dataSource" :props="treeSelectProps" :options="dataUsrTree" style="padding-bottom: 10px;width: 90%"
                             @getValue="getValue" :disabled="!isKFBAdmin"></tree-select>
              </el-form-item>
            </el-col>
<!--            <el-col :span="12">-->
<!--              <el-form-item label="表格标题">-->
<!--                <el-input v-model="form.name"></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24">
              <el-form-item label="表格标题">
                <el-input v-model="form.name" style="padding-bottom: 10px;width: 90%" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="展示内容">
                <el-transfer
                    v-model="choseHeader"
                    :data="theHeader"
                    :props="{
                      key: 'id',
                      label: 'label',
                  }"
                    style="text-align: left; display: inline-block"
                    :titles="['源数据列', '展示列']"
                    target-order="push"
                    filterable
                    filter-placeholder="搜索"
                    @change="choseChange"
                    @right-check-change="rightchange"
                >
                  <template #default="scope">
                    <div :draggable="true" @dragstart="drag(scope.option)" @dragover.prevent @drop="drop($event)">
                      <span @click.prevent="isDrill(scope.option)">{{ scope.option.label }}</span>
                      <el-button @click.prevent.stop style="margin-left: 5px" type="text" size="mini"
                                 v-if="scope.option.router != undefined" class="el-icon-link"></el-button>
                    </div>
                  </template>
                </el-transfer>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="数值位数">
                <el-input-number :min="0" :max="8" v-model="form.decimals" size="medium"/>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-button
                  class="transfer-footer"
                  size="mini"
                  @click="handleUp(index)"
              >
                上移
              </el-button>
              <el-button
                  class="transfer-footer"
                  size="mini"
                  @click="handleDown(index)"
              >
                下移
              </el-button>
              <el-button
                  class="transfer-footer"
                  size="mini"
                  @click="handleTop(index)"
              >
                置顶
              </el-button>
              <el-button
                  class="transfer-footer"
                  size="mini"
                  @click="handleButton(index)"
              >
                置底
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否冻结">
                <el-switch @change="isFixedChange" v-model="form.isFixed"></el-switch>
                <span style="margin-left: 10px">{{ form.isFixed == true ? "是" : "否" }}</span>
              </el-form-item>
              <el-form-item label="冻结几列">
                <el-input-number :disabled="!form.isFixed" size="medium" v-model="form.isFixedNum" :min="0"
                                 :max="choseHeader.length"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="操作列">
                <el-switch v-model="form.operation"></el-switch>
                <span style="margin-left: 10px">{{ form.operation == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-form-item label="分页器">
                <el-switch v-model="form.pagination"></el-switch>
                <span style="margin-left: 10px">{{ form.pagination == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序字段">
                <label>{{ form.dataSortName }}</label>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序方式">
                <div>
                  <el-radio v-model="form.dataSort.way" label="asc" size="small">正序</el-radio>
                  <el-radio v-model="form.dataSort.way" label="desc" size="small">倒序</el-radio>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="configOk">确定</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="drillDialogVisible"
          title="列配置"
          width="400px"
          top="20vh"
          :before-close="handleClose"
          v-show="viewDisplay">
        <el-form label-width="85px" label-position="left">
          <el-form-item v-if="!isDrillOnlyShowOther" label="钻取">
            <el-select ref="treeSelect" v-model="drillValue.drillname" @clear="clearDrill" @click="onSelectPage"
                       clearable @change="selectChange">
              <el-option :value="page" style="height: auto"></el-option>
              <el-tree
                  :highlight-current=true
                  :default-expand-all=false
                  :expand-on-click-node="false"
                  :data="drillingList"
                  :props="defaultProps"
                  node-key="pageid"
                  accordion
                  @node-click="onSelectPage"
                  class="page-tree"
                  ref="pageTree"
                  style="max-width: 230px"
              >
                <template #default="scope">
                <span class="custom-tree-node">
                    {{ scope.data.label }}
                </span>
                </template>
              </el-tree>

            </el-select>
            <span style="margin-left: 5px">{{ routerText }}</span>
          </el-form-item>
          <el-form-item label="是否可编辑">
            <el-switch v-model="drillValue.edit" @change="editChange"></el-switch>
            <span style="margin-left: 5px">{{ drillValue.edit == true ? "是" : "否" }}</span>
          </el-form-item>
          <el-form-item label="列宽">
            <el-input v-model="drillValue.colWidth"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="drillDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="drillChoseOk">确定</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="saveDialogVisible"
          title="配置名称"
          width="400px"
          :before-close="handleClose">
        <el-form>
          <el-form-item label="配置名称">
            <el-input v-model="saveName"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="saveDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveConfigOk">确定</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <!--    配置切换——弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="switchDialogVisible"
          title="配置切换"
          width="30%"
      >
        <el-card>
          <el-form>
            <el-form-item>
              <el-radio-group @change="changeConfig" v-model="switchConfigCame">
                <el-form-item v-for="(i,idx) in configList" :key="i">
                  <el-radio :label="i.config_name" @dblclick="dblclickConfigName(i)">
                    <el-input v-if="i.isShow"
                              :ref="i.config_name"
                              v-model="i.config_name"
                              @blur="updateConfigName(i,idx)" size="small"></el-input>
                    <span v-else>{{ i.config_name }}</span>
                  </el-radio>
                </el-form-item>
                <el-form-item>
                  <el-radio label="defaultTemplate">系统配置模板</el-radio>
                </el-form-item>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-card>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="switchDialogVisible = false">取消</el-button>
          <el-button type="danger" :disabled="ddisable" @click="delConfig">删除</el-button>
          <el-button type="primary" @click="switchConfigOk">确定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
    <!--    筛选查询——弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="refreshDialogVisible"
          title="查询"
          width="680px"
      >
        <el-scrollbar max-height="300px">
          <queryConfig :theHeader="theHeader" ref="queryConfig" v-on:numChange="numChange"></queryConfig>
        </el-scrollbar>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="refreshDialogVisible = false">取消</el-button>
            <el-button @click="refreshReset">置空</el-button>
            <el-button type="primary" @click="refreshOk">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog v-model="verifyDlgVisible" title="审核" destroy-on-close width="500px">
        <template #default>
          <el-form ref="verifyForm" :model="verifyForm" label-width="120px">
            <el-form-item label="*审核结论：">
              <el-select v-model="verifyForm.verifyResult" placeholder="Select">
                <el-option key="1" label="通过" value="1"/>
                <el-option key="0" label="驳回" value="0"/>
              </el-select>
            </el-form-item>
            <el-form-item label="*审核意见：">
              <el-input
                  v-model="verifyForm.verifyRemark"
                  :rows="2"
                  type="textarea"
                  placeholder="请简要填写给出结论的原因"
              />
            </el-form-item>
            <el-form-item label="*下级审核人："
                          v-if="uploadApproval&&auditUserList.length>0&&(verifyForm.verifyResult==1||verifyForm.verifyResult=='通过')"/>
            <el-table
                style="width: 100%"
                stripe
                max-height="300"
                border="10px"
                ref="auditerAprovalTable"
                :data="auditUserList"
                v-if="uploadApproval&&auditUserList.length>0&&(verifyForm.verifyResult==1||verifyForm.verifyResult=='通过')"
                @selection-change="handleAuditerSelChange">
              <el-table-column type="selection" width="55"/>
              <el-table-column prop="name" label="姓名" header-align="center" width="80">
                <template #default="{$index}">
                  <span>{{ auditUserList[$index].username }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="单位" header-align="center" min-width="160px">
                <template #default="{$index }">
                  <span>{{ auditUserList[$index].orgname }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="岗位" header-align="center" min-width="150px">
                <template #default="{$index }">
                  <span>{{ auditUserList[$index].posname }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </template>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="verifyDlgVisible = false">取消</el-button>
            <el-button type="primary" @click="doVerifyOp">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!--综合治理方案审核-->
    <div v-dialogDrag>
      <el-dialog v-model="assessSchemeverifyDlgVisible" title="审核" destroy-on-close width="500px">
        <template #default>
          <el-form ref="verifyForm" :model="assessSchemeVerifyForm" label-width="150px">
            <el-form-item label="*审核结论：" label-width="150px">
              <el-select v-model="assessSchemeVerifyForm.verifyResult" placeholder="Select">
                <el-option key="1" label="通过" value="1"/>
                <el-option key="0" label="驳回" value="0"/>
              </el-select>
            </el-form-item>
            <!--          <el-form-item label="审核轮次：" >-->
            <!--            <el-input-number-->
            <!--                :max="100"-->
            <!--                :min="1"-->
            <!--                :disabled="true"-->
            <!--                v-model="assessSchemeVerifyForm.verifyCnt"-->
            <!--            />-->
            <!--          </el-form-item>-->
            <el-form-item label="*审核评分：" v-if="assessSchemeVerifyForm.verifyResult == '通过'" label-width="150px">
              <el-input-number
                  :max="100"
                  :min="0"
                  :precision="2"
                  v-model="assessSchemeVerifyForm.verifyScore"
              />
            </el-form-item>
            <el-form-item label="*数据质量问题数：" label-width="150px">
              <el-input-number
                  :max="100"
                  :min="0"
                  v-model="assessSchemeVerifyForm.qualityCount"
              />
            </el-form-item>
            <el-form-item label="*审核意见：" label-width="150px">
              <el-input
                  v-model="assessSchemeVerifyForm.verifyRemark"
                  :rows="2"
                  type="textarea"
                  placeholder="请简要填写给出结论的原因"
              />
            </el-form-item>
          </el-form>
        </template>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="assessSchemeverifyDlgVisible = false">取消</el-button>
            <el-button type="primary" @click="doSchemeVerifyOp">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!--      保存配置页面-->
    <div v-dialogDrag>
      <el-dialog
          v-model="viewSelectionWell"
          title="选井"
          width="35%"
      >
        <el-form>
          <el-row>
            <el-col :span="10">
              <el-form-item label="井组1">
                <el-select v-model="relation_grupone_name" @change="onRelationGroupOneChange">
                  <el-option
                      v-for="item in relation_grup_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree
                    class="filter-tree"
                    :data="wellgroupOneData"
                    :props="defaultProps"
                    node-key="id"
                    show-checkbox
                    @check="handleWellCheckOne"
                    default-expand-all
                    :default-checked-keys="gruponeCheckedWell"
                    ref="gruponewellTree">
                </el-tree>
              </el-scrollbar>
            </el-col>
            <el-col span="4"></el-col>
            <el-col :span="10">
              <el-form-item label="井组2">
                <el-select v-model="relation_gruptwo_name" @change="onRelationGroupTwoChange">
                  <el-option
                      v-for="item in relation_grup_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree
                    class="filter-tree"
                    :data="wellgroupTwoData"
                    :props="defaultProps"
                    node-key="id"
                    show-checkbox
                    default-expand-all
                    :default-checked-keys="gruptwoCheckedWell"
                    @check="handleWellCheckTwo"
                    ref="tree">
                </el-tree>
              </el-scrollbar>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="viewSelectionWell = false">取消</el-button>
                    <el-button type="primary" @click="queryGridData(true)">确认</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog v-model="problemCheckDialog" title="错误提示" destroy-on-close :close-on-click-modal="false">
        <template #default>
          <p>勾选记录中存在以下在处理的数据，无法送审，待银行处理完后重试！</p>
          <el-table :data="problemCheckData">
            <el-table-column
                property="SUBMITINFO"
                label="送审记录"
                width="560"
            ></el-table-column>
            <el-table-column
                property="PROBLEMINFO"
                label="已在处理中记录"
                width="220"
            ></el-table-column>
          </el-table>
        </template>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="problemCheckDialog = false">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="importDialogVisible"
          title="数据导入"
          width="680px"
          :close-on-click-modal="false"
      >
        <el-table
            :data="xlsHeader"
            width="100%"
            max-height="600px"

        >
          <el-table-column prop="isPrimary" label="主键" align="center" header-align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row[scope.column.property]" size="large"/>
            </template>
          </el-table-column>
          <el-table-column prop="to" label="目标字段" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="请选择" size="large"
                         @change="dataChange">
                <el-option
                    v-for="item in theHeader"
                    :key="item.COLUMN_NAME"
                    :label="item.COMMENTS"
                    :value="item.COLUMN_NAME"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="Select" size="large">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="from" label="原字段" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="请选择" size="large"
                         @change="dataChange">
                <el-option
                    v-for="item in xlsHeader"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="importDialogVisible = false">取消</el-button>
<!--            <el-button type="primary" @click="dataModify">预览修改</el-button>-->
            <el-button type="primary" @click="modifyOk">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="modifyDialogVisible"
          title="预览修改"
          fullscreen
          :close-on-click-modal="false"
      >
        <el-table
            :data="xlsNow"
            stripe
            height="800"
            style="width: 100%"
            v-loading="modifyLoading"
            @cell-dblclick="editData"
        >
          <el-table-column
              v-for="(item,index) in xlsBody.header"
              :prop="item.data"
              :key="index"
              :label="item.COMMENTS"
              align="center"
              header-align="center"
          >
            <template #default="scope">
              <el-input
                  type="text"
                  v-if=" getModifyType(scope.column.property)==='string' && scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  autofocus
                  v-model="scope.row[scope.column.property]"
                  @input="modifyChange"
                  @blur="alterData(scope.row,scope.column)"
              ></el-input>
              <el-input
                  type="number"
                  v-else-if="getModifyType(scope.column.property)==='number' && scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  autofocus
                  v-model="scope.row[scope.column.property]"
                  @input="modifyChange"
                  @blur="alterData(scope.row,scope.column)"
              ></el-input>
              <el-date-picker
                  v-else-if="getModifyType(scope.column.property)==='date' && scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model="scope.row[scope.column.property]"
                  type="date"
                  size="small"
                  @blur="alterData(scope.row,scope.column)"
              ></el-date-picker>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
          <!--<el-table-column label="操作" align="center" header-align="center">-->
          <!--<template #default="scope">-->
          <!--<el-button size="small" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
          <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
        <el-pagination
            :currentPage="xlsPage"
            :page-size="xlsPageSize"
            :page-sizes="[20,50, 100, 200]"
            :small="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="xlsBody.data.length"
            @size-change="xlsSizeChange"
            @current-change="xlsCurrentChange"
        ></el-pagination>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="modifyDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="modifyOk">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!--    审核用户选择-->
    <div v-dialogDrag>
      <el-dialog
          v-model="auditUserSelDialogVisible"
          title="审核用户选择"
          @closeMsg="auditUserSelDialogVisible=false"
          width="800px"
          height="600px"
      >
        <el-table
            style="width: 100%"
            stripe
            max-height="300"
            border="10px"
            ref="auditerTable"
            :data="auditUserList"
            @selection-change="handleAuditerSelChange">
          <el-table-column type="selection" width="55"/>
          <el-table-column prop="name" label="姓名" header-align="center">
            <template #default="{$index}">
              <span>{{ auditUserList[$index].username }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="单位" header-align="center" min-width="100px">
            <template #default="{$index }">
              <span>{{ auditUserList[$index].orgname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="岗位" header-align="center" min-width="100px">
            <template #default="{$index }">
              <span>{{ auditUserList[$index].posname }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="auditUserSelDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="onAuditUserSelClickOk">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!--    <assessflow-v-chart ref="assesFlowChart" v-if="isAssessAdd"></assessflow-v-chart>-->
    <!--     考核指标发布——弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="isAssessAdd"
          title="考核指标发布"
          width="600px"
      >
        <el-row>
          <el-col :span="24">
            <el-form :model="assessFromData"  label-width="110px" class="fromItem" :rules="rules" ref="assessFrom">
              <el-form-item label="考核年度" prop="year_mon">
                <el-date-picker
                    v-model="assessFromData.year_mon"
                    type="year"
                    value-format="YYYY"
                    placeholder="请选择"
                    style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="考核开始时间" prop="startTime">
                <el-date-picker
                    v-model="assessFromData.startTime"
                    type="day"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择"
                    style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="考核相关附件">
                <el-input v-model="assessFromData.annex" name="assessAnnex" ref="assessAnnex" type="file" placeholder="请选择文件" size="mini" multiple style="width: 80%"/>
                <el-button size="mini" type="primary" @click="assessUpload" style="width: 20%">上传</el-button>
              </el-form-item>
              <el-form-item label="方案提交时间" prop="fakh_sjd">
                <el-date-picker
                    v-model="assessFromData.fakh_sjd"
                    type="monthrange"
                    value-format="YYYYMM"
                    range-separator="至"
                    start-placeholder="开始"
                    end-placeholder="结束"
                    style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公关申请时间" prop="ggsq_sjd">
                <el-date-picker
                    v-model="assessFromData.ggsq_sjd"
                    type="monthrange"
                    value-format="YYYYMM"
                    range-separator="至"
                    start-placeholder="开始"
                    end-placeholder="结束"
                    style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="提交人">
                <el-input v-model="assessFromData.submitter" clearable />
              </el-form-item>
              <el-form-item label="提交时间">
                <el-input v-model="assessFromData.submission_time" clearable />
              </el-form-item>
              <el-form-item label="详细说明">
                <el-input type="textarea" :rows="5" v-model="assessFromData.remarks" clearable />
              </el-form-item>
            </el-form>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <svg width="450px" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="x6-graph-svg"><defs><marker refX="-1" id="marker-v25-959247788" overflow="visible" orient="auto" markerUnits="userSpaceOnUse"><path stroke="#A2B1C3" fill="#A2B1C3" transform="rotate(180)" d="M 0 0 L 12 -4 L 12 4 Z"></path></marker></defs><g class="x6-graph-svg-viewport"><g class="x6-graph-svg-primer"></g><g class="x6-graph-svg-stage"><g data-cell-id="node1" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(80,30)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" rx="20" ry="26" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">考核指标发布</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="8051b32d-b009-483c-b771-bec8b808c4a0" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="4c38c665-9202-4210-ad63-53cbe9e8f051" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="72da4028-3269-4bc9-8cca-5627632b0b10" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="bfe5c953-7916-4684-9211-606599ab7a19" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node2" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(80,130)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">资料送审</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="903286c9-7772-477a-a3b9-29b408a6fc50" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="317d9e88-4492-4938-a959-9cfcc29022b1" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="d80d9297-a4a7-48a7-adc2-4feec81fef39" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="31eb3d70-33e5-48ef-b76f-cd02f64e329f" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node3" data-shape="custom-polygon" class="x6-cell x6-node x6-node-immovable" transform="translate(80,230)"><polygon fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" class="node3Attr" points="0, 25 55, 0 110, 25 55, 50"></polygon><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,55,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">一级审核</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,55,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="8f036f79-694e-4945-ad1c-b002927ee8c1" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,110,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="ffb8ae83-f4ba-46c8-89bf-3923999542c7" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,55,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="251cd1f4-5ad5-4454-bfc0-c193e44557ee" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="eb0f5617-ac03-4824-ac51-a9606693e7c3" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node4" data-shape="custom-polygon" class="x6-cell x6-node x6-node-immovable" transform="translate(80,330)"><polygon fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" class="node4Attr" points="0, 25 55, 0 110, 25 55, 50"></polygon><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,55,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">二级审核</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,55,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="b0fd9038-1b40-4444-b925-c9cf1940335b" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,110,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="0837afc6-7ac0-4cec-9266-253b35353a89" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,55,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="a6e6a411-0f21-4c0b-a57f-1f73a02f1f78" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="4a7bda1e-e22c-435d-bd7a-82c38c8387f7" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node5" data-shape="custom-polygon" class="x6-cell x6-node x6-node-immovable" transform="translate(80,430)"><polygon fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" class="node5Attr" points="0, 25 55, 0 110, 25 55, 50"></polygon><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,55,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">油田公司审核</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,55,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="d63cbcbe-95f8-4322-ad90-05b0fd931348" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,110,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="baa3816a-fc6d-4537-9073-b31353f21143" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,55,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="e8a57c97-8ead-4aec-8585-43e1bb52b389" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="edd4b833-c663-410d-a169-9380f76564f8" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node6" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(80,530)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">资料完善</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="206e6698-d0c1-4efd-bedb-61bef00e5e20" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="aec551dd-7794-483d-b30e-1449ab1bcb29" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="e46e9789-c030-4e3e-9156-acf0c7785d92" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="17cac8c1-2da5-4e84-a9fe-81300a20b671" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node7" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(80,630)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" rx="20" ry="26" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">考核评分发布</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="28837659-e7d8-41a0-b689-d20bb9a78ef1" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="774db3ec-4623-4e08-8b99-5478edf399a1" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="7e50531b-f882-47ef-b855-efc10fbf3dd7" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="14dcb700-4a9b-4c19-a9e7-d818b5cf8737" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node8" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(260,230)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">资料修改</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="27f8dc11-1417-4e18-b415-b62421cf36dd" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="d1863391-063c-4439-8761-3cda1feb0bdd" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="8821ef89-9ffd-4964-98c6-38ae46a6778a" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="aa38fbf4-7d44-4f78-94a5-909c32e8c0f9" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node9" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(260,330)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">资料修改</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="a4454a23-7227-43bc-8adb-71e2442ee88e" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="f7003f9a-52a6-4cd0-a449-ac77c505b424" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="31001ec2-d2c5-4970-b2d8-2781e1cac709" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="40f412f4-f2da-473a-951c-179689aa56d5" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="node10" data-shape="custom-rect" class="x6-cell x6-node x6-node-immovable" transform="translate(260,430)"><rect fill="#EFF4FF" stroke="#5F95FF" stroke-width="1" width="100" height="50"></rect><text font-size="16" fill="#262626" text-anchor="middle" font-family="Arial, helvetica, sans-serif" transform="matrix(1,0,0,1,50,25)" xml:space="preserve"><tspan class="v-line" dy="0.3em">资料修改</tspan></text><g class="x6-port" transform="matrix(1,0,0,1,50,0)"><circle r="4" fill="#fff" stroke="#5F95FF" port="62285bd2-89d6-4f1d-a88c-619263cb0358" port-group="top" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,100,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="265d3a1a-6c52-41ab-adc2-357fec548715" port-group="right" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,50,50)"><circle r="4" fill="#fff" stroke="#5F95FF" port="89883d8d-0951-47dd-a61a-257e545de307" port-group="bottom" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g><g class="x6-port" transform="matrix(1,0,0,1,0,25)"><circle r="4" fill="#fff" stroke="#5F95FF" port="9f238121-9f7d-41d0-8ae2-d65ad6dea16f" port-group="left" class="x6-port-body" style="visibility: hidden;" magnet="true" stroke-width="1"></circle><text fill="#000000" class="x6-port-label" transform="matrix(1,0,0,1,-15,0)" y=".3em" text-anchor="end"></text></g></g><g data-cell-id="Edge1" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 130 80.5 L 130 127.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 130 80.5 L 130 127.5" marker-end="url(#marker-v25-959247788)"></path></g><g data-cell-id="Edge2" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 130 180.5 L 130 213 C 130 214.33 130.67 215 132 215 L 133 215 C 134.33 215 135 215.67 135 217 L 135 227.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 130 180.5 L 130 213 C 130 214.33 130.67 215 132 215 L 133 215 C 134.33 215 135 215.67 135 217 L 135 227.5" marker-end="url(#marker-v25-959247788)"></path></g><g data-cell-id="Edge3" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 135 280.5 L 135 327.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 135 280.5 L 135 327.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,135,304)"><rect fill="#fff" rx="3" ry="3" width="27.600000381469727" height="13.800000190734863" transform="matrix(1,0,0,1,-13.800000190734863,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">通过</tspan></text></g></g></g><g data-cell-id="Edge4" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 135 380.5 L 135 427.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 135 380.5 L 135 427.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,135,404)"><rect fill="#fff" rx="3" ry="3" width="27.600000381469727" height="13.800000190734863" transform="matrix(1,0,0,1,-13.800000190734863,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">通过</tspan></text></g></g></g><g data-cell-id="Edge5" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 135 480.5 L 135 513 C 135 514.33 134.33 515 133 515 L 132 515 C 130.67 515 130 515.67 130 517 L 130 527.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 135 480.5 L 135 513 C 135 514.33 134.33 515 133 515 L 132 515 C 130.67 515 130 515.67 130 517 L 130 527.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,135,505.7445373535156)"><rect fill="#fff" rx="3" ry="3" width="27.600000381469727" height="13.800000190734863" transform="matrix(1,0,0,1,-13.800000190734863,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">通过</tspan></text></g></g></g><g data-cell-id="Edge6" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 130 580.5 L 130 627.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 130 580.5 L 130 627.5" marker-end="url(#marker-v25-959247788)"></path></g><g data-cell-id="Edge7" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 190.5 255 L 257.5 255"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 190.5 255 L 257.5 255" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,224,255)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g><g data-cell-id="Edge8" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 310 229.5 L 310 217 C 310 215.67 309.33 215 308 215 L 137 215 C 135.67 215 135 215.67 135 217 L 135 227.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 310 229.5 L 310 217 C 310 215.67 309.33 215 308 215 L 137 215 C 135.67 215 135 215.67 135 217 L 135 227.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,223.5,215)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g><g data-cell-id="Edge9" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 190.5 355 L 257.5 355"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 190.5 355 L 257.5 355" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,224,355)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g><g data-cell-id="Edge10" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 310 329.5 L 310 317 C 310 315.67 309.33 315 308 315 L 137 315 C 135.67 315 135 315.67 135 317 L 135 327.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 310 329.5 L 310 317 C 310 315.67 309.33 315 308 315 L 137 315 C 135.67 315 135 315.67 135 317 L 135 327.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,223.5,315)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g><g data-cell-id="Edge11" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 190.5 455 L 257.5 455"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 190.5 455 L 257.5 455" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,224,455)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g><g data-cell-id="Edge12" data-shape="edge" class="x6-cell x6-edge"><path fill="none" cursor="pointer" stroke="transparent" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M 310 429.5 L 310 417 C 310 415.67 309.33 415 308 415 L 137 415 C 135.67 415 135 415.67 135 417 L 135 427.5"></path><path fill="none" pointer-events="none" stroke-linejoin="round" stroke="#A2B1C3" stroke-width="2" d="M 310 429.5 L 310 417 C 310 415.67 309.33 415 308 415 L 137 415 C 135.67 415 135 415.67 135 417 L 135 427.5" marker-end="url(#marker-v25-959247788)"></path><g class="x6-edge-labels"><g class="x6-edge-label" data-index="0" cursor="default" transform="matrix(1,0,0,1,223.5,415)"><rect fill="#fff" rx="3" ry="3" width="41.400001525878906" height="13.800000190734863" transform="matrix(1,0,0,1,-20.700000762939453,-7.300000190734863)"></rect><text fill="#000" font-size="11" text-anchor="middle" pointer-events="none" xml:space="preserve"><tspan class="v-line" dy="0.3em">未通过</tspan></text></g></g></g></g><g class="x6-graph-svg-decorator"></g><g class="x6-graph-svg-overlay"></g></g></svg>-->
<!--          </el-col>-->
        </el-row>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="isAssessAdd = false">取消</el-button>
                <el-button type="primary" @click="assessAddOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableControl from '@/components/tableControl.vue';
import docFileUploader from "@/components/docFileUploader";
import queryConfig from "@/components/queryConfig.vue";
import axios from 'axios';
import XLSX from "xlsx";
import {ElMessage, ElMessageBox} from 'element-plus'
import AssessflowVChart from "@/components/assessflowVChart";
import moment from 'moment';

import treeSelect from "@/components/treeSelect";
import BlockSelect from "@/components/blockSelect";
import YjcgFilter from "@/components/yjcgFilter";

function docShow(docurl, docName) {
  console.log(window.frames);
  // let docurl2 = docurl.replace("\\", "/");
  console.log(docurl,docName)
  let transData = {
    projectId: '',
    entityId: "",
    // fileSourceUrl: docurl,
    fileSourceUrl: encodeURI(encodeURI(docurl)),
    fileFullName: docName
  }
  console.log("文件展示信息：", transData);
  //初始化
  document.getElementById('docShow').contentWindow.postMessage(
      {
        command: "initFile",
        type: "url",
        readOnly: true,
        data: transData
      },
      "*"
  )
}

export default {
  name: "table-view",
  components: {
    YjcgFilter,
    BlockSelect,
    AssessflowVChart,
    tableControl,
    docFileUploader,
    queryConfig,
    // tjFileUploader,
    // gqDirectoryUploader
    treeSelect,
  },
  props: {
    mountedDoNothing:{
      default:false
    },
    templateInfo: {
      default: ""
    },
    uploadStatus: {
      default: 0
    },
    uploadType: {
      default: ""
    },
    selectable: {
      default: false
    },
    dataScreen:{
      default: false
    },
    dataScreenApproval:{
      default: false
    },
    assessSchemeApproval:{
      default: false
    },
    uploadApproval:{
      default: false
    },
    uploadList:{
      default: false
    },
    checkSelectablefield:{
      default:"status"
    },
    sendVerify: {
      default: false
    },
    sendVerifyCheckUrl:{
      default: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/checkProblemList"
    },
    sendVerifyUrl:{
      default: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/sendProblemListToVerify"
    },
    doVerifyUrl:{
      default: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/verifyProblemList"
    },
    doVerify: {
      default: false
    },
    moduleManager: {
      default: null
    },
    showGridCfg: {
      default: true
    },
    homePageManager: {
      default: null
    },//首页检索调用标识
    homeCheckedBlkId: {
      default: ""
    },//首页检索传参：curCheckedBlkId
    isWork:{
      default: false
    },
    isYearMonDay:{
      default: false
    },
    isYearMonth:{
      default: false
    },
    isYear:{
      default: false
    },
    iswellGroup:{
      default: false
    }
  },
  data() {
    return {
      isShowDocReviewSwitch:false,//是否展示预览窗开关
      showDocView:false,//展示预览窗
      routeImgUrl: "",//图像预览地址
      docShowIframeUrl: "",//文档预览地址
      routeImgType: "",//图像预览类型
      curSelAuditer:[],//当前选中的审核用户
      auditUserSelDialogVisible:false,//审核用户选择对话框
      auditUserList:[],//审核用户列表
      isKFBAdmin:false,//是否是开发部人员或管理员
      gruponeCheckedWell:[],//井组1默认选中井
      gruptwoCheckedWell:[],//井组1默认选中井
      wellgroupOneData:[],//井列表
      wellgroupTwoData:[],//井列表
      relation_grupone_name:{},
      relation_gruptwo_name:{},
      relation_grupone_wells:[],//井组1列表
      relation_gruptwo_wells:[],//井组2列表
      relation_grup_list:[],//井组列表-当前用户井组及自定义选择模式
      isManager:false,
      curDrillObj:{},
      showuploadtablefileBtn:false,
      isKhEnableUpload:false,//考核是否支持编辑
      isZBGZModule:false,//是否是指标跟踪表
      isZBFXModule:false,//是否是指标分析表
      isKHModule:false,//是否是考核模块
      showCalcBtn:false,
      time:null,
      gridIsInited:false,
      excelkKey:"",//数据导入文件标识
      myFiles:[],//数据导入文件对象
      drillJH:"",
      drillBlock:"",
      pageid:"",//保存模板时，用于区分是否是系统模板
      isPublicConfig:false,//保存模板时，用于判断是否是公用模板
      typeOptions:[{
        label:"字符串",
        value:"string"
      },{
        label:"日期",
        value:"date"
      },{
        label:"数值",
        value:"number"
      }],//数据导入类型列表
      info:{},//组件信息
      modifyLoading:false,
      problemCheckData:[],
      problemCheckDialog:false,
      verifyDlgVisible: false,//审核流程对话框
      assessSchemeverifyDlgVisible: false,//审核流程对话框
      switchConfigCame:"",
      refreshDialogVisible:false,//查询页面是否开启
      switchDialogVisible:false,//切换配置页面是否开启
      saveDialogVisible:false,//保存配置页面是否开启
      dialogVisible:false,//配置页面是否开启
      drillDialogVisible:false,//钻取页面是否开启
      isDrillOnlyShowOther:false,//钻取页面仅显示钻取外的其它操作
      importDialogVisible:false,//数据导入页面
      modifyDialogVisible:false,//数据导入更正
      verifyForm:{
        verifyResult:"通过", //审核结论：0驳回 1通过
        verifyRemark:""
      },
      assessSchemeVerifyForm:{//综合治理方案审核
        verifyResult:"通过", //审核结论：0驳回 1通过
        verifyRemark:"",//审核意见
        verifyScore:"0",//评分
        qualityCount:"0",//数据质量问题个数
        verifyCnt:"1"//当前审核轮次
      },
      form:{
        name:"",//表格名称
        isFixed:false,//是否开启冻结
        isFixedNum:0,//冻结行数
        data:[],//数据
        dataNum:0,//总页数
        pagination:true,//分页器
        dataSource:"",//所选数据源
        dataSourceTree:"",//所选数据源(级联选择器)
        operation:false,//操作列
        dataSort: {
          fieldStr:"",
          way:"asc",
        },//排序字段
        dataSortName:"暂无排序字段",//排序字段中文名
        pKey:null,//主键
        decimals:2,//数值位数
      },
      page: {
        pageid: "",
        seq: 0,
        label: "",
        remark:"",
        pid: "root",
        lev: 1,
        isLeaf: false,
        type: "",
        route: "",
        template: []
      },
      xlsData:[],//上传excel文件数据
      xlsHeader:[],//上传excel文件表头
      xlsBody:{},//数据导入预览修改
      xlsPage:1,//数据导入分页
      xlsPageSize:20,//数据导入分页
      xlsNow:[],//数据导入当前页
      gridCfg:{},//表格配置
      queryFilter:[],//查询条件
      configList:[],//配置切换列表
      setName:"",//配置名称（未修改）
      configName:"",//当前使用配置模板名称（修改后）

      dataSource:null,//数据源列表
      dataUsrTree:null,//数据源列表（树形结构）
      drillingList:[],//钻取下拉数据列表——页面配置数据(树形结构）
      theHeader:[],//原本数据列
      choseHeader:[],//已选择的列(记录的是id的值，不是序号)
      isManyHeader:false,//多级表头启用标识
      ManyHeader:[],//多级表头列表
      clickNum:0,//配置键的点击次数
      jsons:{},//要传递的数据
      drillValue:{},//列配置当前数据
      options:[],//钻取下拉
      routerText:"空",//钻取类型
      viewDisplay: true, // 模块管理控制组件隐藏
      saveName:"",//配置保存对话框中的名称
      dModuleManager:this.moduleManager,//调用模板的相关信息（检索模块，页面配置模块。。）
      ddisable:true,
      curSelRowArray: [],//记录勾选中的数据信息
      total: 15,//分页
      pageCount:1,//总页数
      currentPage: 1,//当前页数
      pageSize: 20,//每页所展示的数量
      curCheckedBlkId: "",//当前选中的区块ID字符串列表,
      curBlkTypeId: "",//当前区块类型ID 01 一期区块 02 银行区块, 03 计划区块
      queryConfigNum:{
        num1:1,
        num2:1
      },//条件查询的唯一表示
      isDefaultTemplate:false,//是否使用默认模板（页面配置表配置信息）标识
      unionConfig:{},//联合数据源相关配置信息
      fromataCopy:[],
      frameTime: ["202201","202212"],//选择范围时间数据(年月)
      frameYear:{
        startTime: null,//开始时间
        endTime: null,//结束时间
      },//选择范围时间数据（年度）
      isNeedTimeSwitch:false,//是否支持日期切换
      frameTimeSpot: null,//选择一个时间点
      frameTimeType:false,//使用时间类型标识 false：范围时间 ，true：时间点
      frameQueryFilter:null,//拼接时间查询条件
      keyword: "2022-09",
      viewSelectionWell:false,//控制选井窗口隐藏
      defexpandBlk: [1],//井组—关联井 默认展开列
      defcheckedBlk: [],//井组—关联井 默认勾选列
      organizationList:{},//预警单位列表

      selecTable:this.selectable,//获取父组件的报表勾选显示标识
      checkSelecTableField:this.checkSelectablefield,//获取父组件控制报表勾选状态字段名称
      upload_status:this.uploadStatus,//是否启用上传组件标识
      upload_type:this.uploadType,//上传文件类型
      homepage_mgr:this.homePageManager,//数据检索页
      isSendVerify:this.sendVerify,//获取父组件报表送审显示状态
      sendtoVerifyUrl:this.sendVerifyUrl,//获取父组件送审地址

      isAssessAdd:false,//考核界面，新增弹出框标识
      assessFromData:{
        year_mon:"",//年度
        startTime:"",//开始时间
        annex:"",//附件
        fakh_sjd:"",//方案考核时间段
        ggsq_sjd:"",//攻关申请时间段
        index_plan:"查看",//指标方案
        submitter:"",//提交人
        submission_time:"",//提交时间
        remarks:"",//详细信息
      },//考核相关数据
      assessIndexList:[
        {
          label:"指标方案1",
          value:"1",
        },
        {
          label:"指标方案2",
          value:"2",
        },
        {
          label:"指标方案3",
          value:"3",
        },
      ],//指标方案列表
      rules: {
        startTime: [{type:"date", required: true, message: '请选择时间', trigger: 'change',},],
        year_mon: [{type:"date", required: true, message: '请选择时间', trigger: 'change',},],
        fakh_sjd: [{type:"array", required: true, message: '请选择时间段', trigger: 'change',},],
        ggsq_sjd: [{type:"array", required: true, message: '请选择时间段', trigger: 'change',},],
        index_plan: [{required: true, message: '请选择指标方案', trigger: 'change',},],
      },//考核新增表单验证规则

      treeSelectProps: {
        value: 'DATSRC_ID',             // ID字段名
        label: 'DATSRC_NAME',         // 显示名称
        children: 'children'    // 子级字段名
      },//树形下拉框传递参数的对应关系


      isIndexDataShow:false,//指标分析，完成情况页面标识
      moduleidList: [
        "728D1693A1B44BC8B66CF10FC4983AC2",
        "DDB27048E6D74C699202414D93F62834",
        "35F8887E05954E9EA2E82FA628EE1A1E",
        "3A0FA77400C84AA6AFFEE6D4B1F2BEF6",
        "43C64EFABE51400793A94C64E3E301EE",
        "2CA8B36609C5489D93F1634E83EDF0FF",
        "A774A4634DE14CA18ABE4328E77639A5",
        "63017CF6099E4B8394E6158414BFCB93",
        "64C41964F415455AB2A19205FD961E60",
        "64C41964F415455AB2A19205FD961E60",
        "A61B81F94CF443FFBAD72E6506BB4DCB",
        "08576A0E6AF84888B7611F8A83D349C0",
        "A88E433EF57C415EB9477046AD876AFF",
        "DCB6698289874848B1B1CC7EA5870E06",
      ],//指标分析,完成情况模块id
      isDeleteRecordShow:false,//删除记录按钮标识
      editTableList:[],//报表修改数据记录
      wellDataClickNum:0,//研究井位点击次数
      noRefreshDrillObj:false,//默认改变drillObj不刷新

      viewTableControl:true,//控制报表显示（数据录入）
      viewEnterBtn:false,//控制录入按钮显示（数据录入）
      addTableDataList:[],//添加报表数据记录列表（数据录入）
      selectDataList:[],//下拉框数据列表（数据录入）
      cslxSelectObj:{},//措施类别数据集
      isInfinite:false,//无限滚动加载标识

      blockSelectShow:false,//控制区块选择框显示
      isShowSaveBtn:false,//是否显示保存按钮

      licProducts:{},//许可-产品名称
      licProductVersionMap:{},//许可-产品版本字典
      licConfig:{
        licDaysMin:1, //最小许可有效天数
        licDaysMax:90,//最大许可有效天数
        licCountMin:1,//最小许可申请数量
        licCountMax:2 //最大许可申请数量
      },//许可其它配置
      // licMaxNumber:2,//许可最大申请数
      licSQDate:new Date(),//申请日期
      // licMaxEnableDays:90,//许可最大有效天数
      licClass:{},//许可类型 正式 临时
      licCustomUnit:{},//客户归属单位 [中石油]***油田
      maxInputNumber:9999999999,//最大输入数值
      minInputNumber:1,//最大输入数值
    }
  },
  async mounted(){
    let jwtSession = localStorage.getItem("lyqtJwt");
    let userRoleData = [];
    let that = this;

    that.isManager = false;
    axios({
      url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getUserRole",
      headers: {
        "Authorization": "Bearer " + jwtSession
      },
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        userRoleData = res.data.data;
        if(userRoleData.length>0)
        {
          for(let roleIdx=0; roleIdx<userRoleData.length;roleIdx++){
            //console.log("userRole",userRoleData[roleIdx]);
            if(userRoleData[roleIdx].name.indexOf("管理员")>=0) that.isManager = true;
          }
        }
      }
    }).catch((err) => {
      alert('Error');
      console.log(err)
    })
    // this.judgeType();
    let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
    this.isKFBAdmin = true;
    // await axios({
    //   url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/isKFBAdmin?orgid="+lyqtUserInfo.belongOrgId,
    //   method: 'GET',
    // }).then((res) => {
    //   if (res.status === 200) {
    //     if(res.data.isKFBAdmin == true)
    //     {
    //       this.isKFBAdmin = true;
    //     }
    //     else{
    //       this.isKFBAdmin = false;
    //     }
    //   }
    // }).catch((err) => {
    //   console.log(err)
    // })

    // 从模块管理打开，不加载初始配置
    this.curDrillObj =  this.$store.state.drillObj == undefined?undefined: JSON.parse(JSON.stringify(this.$store.state.drillObj));
    console.log("store:",this.$store.state,this.curDrillObj)
    this.$store.state.drillObj = undefined;
    if (this.dModuleManager != null) {
      this.viewDisplay = false;
      return;
    }
    this.$store.state.isDriing = 0;
    let iswarrning = this.$store.state.isWarDriing;
    // this.$store.state.isWarDriing = 0;
    if(iswarrning ==1){
      let drillObj = {};
      if(this.$store.state.warningReadData.compareDate != undefined && this.$store.state.warningReadData.compareDate.length!=0){
        if(this.$store.state.warningReadData.compareDate == "前一天") {
          if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
            let startTime = this.getNowDate(2, 2);
            let endTime = this.getNowDate(2, 1);
            this.frameTime = [startTime, endTime];
            console.log(this.frameTime)
          }
        }
        else if(this.$store.state.warningReadData.compareDate.indexOf("前")>=0){
          //前N天
          let nNum = this.$store.state.warningReadData.compareDate;
          nNum = parseInt(nNum.replace("前","").replace("天",""));
          if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
            let startTime = this.getNowDate(2, nNum+1);
            let endTime = this.getNowDate(2, 1);
            this.frameTime = [startTime, endTime];
            console.log(this.frameTime)
          }
        }
        else{
          //指定日期 xxxx-xx-xx
          if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
            let startTime = this.$store.state.warningReadData.compareDate;
            let endTime = this.getNowDate(2, 1);
            this.frameTime = [startTime, endTime];
            console.log(this.frameTime)
          }
        }
      }
      if(this.$store.state.warningReadData.JH != undefined && this.$store.state.warningReadData.JH.length!=0){
        drillObj.type = 1;
        drillObj.value = [{id:this.$store.state.warningReadData.JH,
          text:this.$store.state.warningReadData.JH}];
        this.curDrillObj =drillObj;
      }
    }
    console.log("mountedWarInfo:",this.curDrillObj,this.$store.state.warningReadData)

    console.log("templateInfoMounted:",this.templateInfo);
    let defaultFrameTime=[];//模块默认时间
    let curObj =this.curDrillObj;
    if(this.templateInfo.moduleid !=null ){
      if(this.templateInfo.moduleid=='7F5756DD008345D78012745632D6EE95'){
        this.isShowDocReviewSwitch = true;
      }
      if(this.$route.name != undefined && this.$route.name.length>3){
        let routeNameLeftStr = this.$route.name.substring(0,3);
        if(routeNameLeftStr == "2-5" || routeNameLeftStr == "2-6" || routeNameLeftStr == "2-7"){
          this.isShowDocReviewSwitch = true;
        }
      }
      this.blockSelectShow=true;
      this.$nextTick(() => {
        console.log("8848",curObj,this.curDrillObj)
        this.curDrillObj = curObj;
      })
      await axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/isEnableUpload?moduleid="+this.templateInfo.moduleid,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          console.log("Mounted3:",res);
          this.showuploadtablefileBtn = res.data.isEnable;
          defaultFrameTime=res.data.defaultFrameTime;
        }
      }).catch((err) => {
        console.log(err)
      })
      let showCalcBtnMap = {"a2ecb45de2844e02a1ecad12165a55c4":1};
      // console.log("Mounted2:",uploadTableModuleMap);
      // console.log("Mounted3:",uploadTableModuleMap[this.templateInfo.moduleid]);
      if(showCalcBtnMap[this.templateInfo.moduleid] == 1){
        this.showCalcBtn = true;
      }
      else{
        this.showCalcBtn = false;
      }
      // console.log("Mounted3:",this.showuploadtablefileBtn);
    }
    if(iswarrning == 0) {
      if (this.templateInfo.type != null && (this.templateInfo.type.indexOf('table_day') != -1||this.isYearMonDay)) {
        let startTime = this.getNowDate(2, 31);
        let endTime = this.getNowDate(2, 1);
        this.frameTime = [startTime, endTime]
      }
      else if (this.templateInfo.type != null && (this.templateInfo.type.indexOf('table_mon') != -1||this.isYearMonth || this.templateInfo.type.indexOf('table_enter_csj')!=-1)) {
        let startTime = this.getNowDate(1, 12);
        let endTime = this.getNowDate(1, 0);
        this.frameTime = [startTime, endTime];
      }
      else if (this.templateInfo.type != null && (this.templateInfo.type.indexOf('table_year') != -1||this.isYear)) {
        let startTime = this.getNowDate(0, 11);
        let endTime = this.getNowDate(0, 0);
        this.frameTime = [startTime, endTime];
      }
      //初始化替换模块默认时间
      if (defaultFrameTime.length>0){
        this.frameTime=defaultFrameTime;
      }
      //同一模块切换页面 时间保持不变
      if (this.$store.state.keepTime && this.$store.state.frameTime.length>0)
        this.frameTime=this.$store.state.frameTime;
      if(this.frameTime == undefined || (this.frameTime!=undefined && this.frameTime[0]==undefined)){
        this.frameTime = defaultFrameTime;
      }
      console.log("watchframeTime:",this.frameTime,defaultFrameTime);
    }

    if(this.templateInfo && this.templateInfo.mouduleid != undefined){
      this.initGrid();
    }
    this.judgePageType();
    this.gettableSource();
    try {
      if(!this.mountedDoNothing){
        if(this.templateInfo.type!=null || this.templateInfo.type!=undefined) this.initGrid();
      }
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    getHeadFilter(item) {
      let filters = null;
      if(item.TABLE_NAME === "GPT_LIC_PRODUCTINFO_VIEW" && item.COLUMN_NAME === "GPT_PRODUCT_NAME"){
        filters = [];
        filters.push({text: "GPTMap", value: "GPTMap"});
        filters.push({text: "GPTLog", value: "GPTLog"});
        filters.push({text: "GPTModel", value: "GPTModel"});
        filters.push({text: "GPTEva", value: "GPTEva"});
      }
      return filters;
    },
    filterHandler(value,row,column){
      return row[column.property] === value
    },
    // judgeType(){
    //
    // },
    getHeadWidth(item){
      if(this.$refs.tableControl.needReCalColWidth) {
        //不是数值或为0则elmui自动处理，否则返回指定宽度
        return parseFloat(item.WIDTH).toString() == "NaN"?undefined:(item.WIDTH===0?undefined:item.WIDTH);
      }
      // console.log("tbctrl.item",item)
      let width = item.WIDTH==='AUTO'?(item.label.length+2-(item.label.includes('(')&&item.label.includes(')')?item.label.indexOf(')')-item.label.indexOf('('):0))*26:item.WIDTH===0?undefined:item.WIDTH;
      if(item.WIDTH ===0||item.WIDTH ===undefined)
        width = (item.label.length+2-(item.label.includes('(')&&item.label.includes(')')?(item.label.indexOf(')')-item.label.indexOf('('))*0.5:0))*23;
      // console.log(width)
      return width;
    },
    onAuditUserSelClickOk(){//审核用户已选择
      let nextOpUserStr = "";
      this.curSelAuditer.forEach(item=>{
        if(nextOpUserStr!="") nextOpUserStr+=";";
        nextOpUserStr+=item.empid
      })
      this.doUploadSubmitWithUserList(nextOpUserStr);
      // console.log("userselAuditer",nextOpUserStr)
      this.auditUserSelDialogVisible = false;
      this.auditUserList = [];
    },
    setCheckWells(wellNodes){
      for(let i=0;i<wellNodes.length;i++){
        let wellNode = wellNodes[i];
        if(wellNode.children == null || wellNode.children == undefined){
          this.gruponeCheckedWell.push(wellNode.id);
          this.relation_grupone_wells.push(wellNode.label);
        }
        else{
          this.setCheckWells(wellNode.children);
        }
      }
    },
    setGrupTwoCheckWells(wellNodes){
      for(let i=0;i<wellNodes.length;i++){
        let wellNode = wellNodes[i];
        if(wellNode.children == null || wellNode.children == undefined){
          this.gruptwoCheckedWell.push(wellNode.id);
          this.relation_gruptwo_wells.push(wellNode.label);
        }
        else{
          this.setGrupTwoCheckWells(wellNode.children);
        }
      }
    },
    async onRelationGroupOneChange(val){
      console.log("当前选择井组1",val)
      this.gruponeCheckedWell = []
      this.relation_grupone_wells = []
      this.wellgroupOneData=[]
      if(val == "auto"){
        this.$nextTick(() => {
          this.wellgroupOneData=this.$store.getters.getWellgroupData;
        })
      }
      else{
        await this.getUserWellData(val);
      }

    },
    //获取井数据
    async getUserWellData(wellGrpID) {
      let that = this;
      let wellDataUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let wellGrpObj = {}
      wellGrpObj[wellGrpID] = wellGrpID;
      await axios({
        url: wellDataUrl,
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: wellGrpObj
      }).then((res) => {
        if (res.status === 200) {
          that.wellgroupOneData = res.data;
          if(this.wellgroupOneData != undefined && this.wellgroupOneData != null){
            this.setCheckWells(this.wellgroupOneData)
          }
          else {
            that.wellgroupOneData = []
          }
        }
        that.loading = false;
      }).catch((err) => {
        console.log(err)
        that.wellgroupOneData = []
      })
    },
    //获取用户权限区块
    async getUserBlockData(){
      let _this = this;
      _this.relation_grup_list=[];
      let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
      //this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userBlockData"+`?userId=${lyqtUserInfo.userId}`;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      await axios({
        url: blkDataUrl,
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          _this.relation_grup_list = res.data[0].children;
          _this.relation_grup_list.push({value:"auto",label:"自定义选择"});
          console.log("区块：",_this.relation_grup_list);
        }
      }).catch((err) => {
        // alert('Error');
        _this.relation_grup_list.push({value:"auto",label:"自定义选择"});
        console.log(err)
      })
    },
    async onRelationGroupTwoChange(val){
      console.log("当前选择井组2",val)
      this.gruptwoCheckedWell = []
      this.relation_gruptwo_wells = []
      this.wellgroupTwoData=[]
      if(val == "auto"){
        this.$nextTick(() => {
          this.wellgroupTwoData=this.$store.getters.getWellgroupData;
        })
      }
      else{
        await this.getGrupTwoWellData(val);
      }

    },
    //获取井数据
    async getGrupTwoWellData(wellGrpID) {
      let that = this;
      let wellDataUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let wellGrpObj = {}
      wellGrpObj[wellGrpID] = wellGrpID;
      await axios({
        url: wellDataUrl,
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: wellGrpObj
      }).then((res) => {
        if (res.status === 200) {
          that.wellgroupTwoData = res.data;
          if(this.wellgroupTwoData != undefined && this.wellgroupTwoData != null){
            this.setGrupTwoCheckWells(this.wellgroupTwoData)
            console.log("Grup2Wells:",this.relation_gruptwo_wells)
          }
          else {
            that.wellgroupTwoData = []
          }
        }
        that.loading = false;
      }).catch((err) => {
        console.log(err)
        that.wellgroupTwoData = []
      })
    },
    //查询数据源列表信息
    async gettableSource() {
      //查询钻取下拉列表信息
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/drillpage",
        method: 'GET',
      }).then((res) => {
        console.log("钻取列表:",res);
        this.drillingList = res.data;
      }).catch(err=>{
        console.log(err);
      });
      console.log("钻取列表2:",this.drillingList);
      //获取下拉列表数据
      await axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasource")
          .then(res => {
            console.log("下拉框数据源信息：", res.data)
            this.dataSource = res.data.datas;
          }).catch(err=>{
            console.log(err);
          });
      // 获取下拉列表数据（树形结构）
      await axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/tableSource", {
        params: {
          user_id: "01",
          app_id: "02"
        },
      }).then(res => {
        this.dataUsrTree = res.data.dataTree;
        console.log("数据源列表(树形):", res.data);
      }).catch(err => {
        console.log(err)
      });
    },
    //判断页面类型，并初始化相应的变量值
    judgePageType(){
      //综合整理考核评分页面,
      console.log("judgePage",this.templateInfo)
      if (this.templateInfo.type == "table_assess"){
        this.selecTable = true;//报表显示勾选
        this.checkSelecTableField="PUBLISHER";
      }
      //动态监测资料上传页面
      if (this.templateInfo.type == "table_upload_dynamic"){
        this.upload_status = 1;//启用上传组件
        this.upload_type="mater";//确定上传页面类型
        this.checkSelecTableField="sh_stat";
        this.isSendVerify = true;
        this.sendtoVerifyUrl=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assessCommon/submitToVerify";
        this.selecTable = true;//报表显示勾选
        this.isDeleteRecordShow=true;//启用删除记录按钮
        this.checkSelecTableField = "upload";
      }
      //安全生产上传页面
      if (this.templateInfo.type == "table_upload_produce"){
        this.upload_status = 1;//启用上传组件
        this.upload_type="produce";//确定上传页面类型
        this.checkSelecTableField="sh_stat";
        this.isSendVerify = true;
        this.sendtoVerifyUrl=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assessCommon/submitToVerify";
        this.selecTable = true;//报表显示勾选
        this.isDeleteRecordShow=true;//启用删除记录按钮
        this.checkSelecTableField = "upload";
      }
      //攻关申请上传页面
      if (this.templateInfo.type == "table_upload_tackle"){
        this.upload_status = 1;//启用上传组件
        this.upload_type="tackle";//确定上传页面类型
        this.checkSelecTableField="sh_stat";
        this.isSendVerify = true;
        this.sendtoVerifyUrl=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assessCommon/submitToVerify";
        this.selecTable = true;//报表显示勾选
        this.isDeleteRecordShow=true;//启用删除记录按钮
        this.checkSelecTableField = "upload";
      }
      //综合治理方案上传页面
      if (this.templateInfo.type == "table_upload_scheme"){
        this.upload_status = 1;//启用上传组件
        this.upload_type="scheme";//确定上传页面类型
        this.checkSelecTableField="sh_stat";
        this.isSendVerify = true;
        // this.sendtoVerifyUrl="http://127.0.0.1:9203/dataprovider/businessdata/assess/submitToVerify";
        this.sendtoVerifyUrl=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/submitToVerify";
        this.selecTable = true;//报表显示勾选
        this.isDeleteRecordShow=true;//启用删除记录按钮
        this.checkSelecTableField = "upload";
      }
      //文档，工区，图件，工作上传
      if (this.upload_type=="Doc" || this.upload_type=="Gq" || this.upload_type=="Tj" || this.upload_type=="Work" ){
        this.isDeleteRecordShow=true;//启用删除记录按钮
      }
      //评分异议记录页面
      if (this.templateInfo.type == "table_assess_obj"){
        //this.upload_status = 1;//启用上传组件
        //this.upload_type="assesObj";//确定上传页面类型
        this.checkSelecTableField="STATUSNAME";
        this.isSendVerify = true;
        this.selecTable = true;
        this.sendtoVerifyUrl=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assessObj/submitToVerify";
      }
      //措施井报表录入页面
      if (this.templateInfo.type == "table_enter_csj"){
        this.viewEnterBtn = true;//显示录入按钮
        // this.showuploadtablefileBtn = true;//显示导入按钮
        // this.isYearMonth=true;//顯示年月時間框
      }

      //指标分析，完成情况页面标识
      if (this.isYearMonth || this.isYear || (this.templateInfo.type!=undefined && (this.templateInfo.type=='table_mon' ||this.templateInfo.type==('table_year') || this.templateInfo.type.indexOf('table_enter_csj')!=-1))){
        this.isIndexDataShow=true;
      }
      //考核指标上报记录
      if(this.templateInfo.pageid == '8643efc26459411582de36cb71c7c938'){
        this.isDeleteRecordShow=true;//启用删除记录按钮
      }
      this.moduleidList.forEach(item=>{
        if (this.templateInfo.moduleid==item)
          this.isIndexDataShow=true
      })

      let needSaveModuleIdList = ["c1b3d60a41134c85bdba239413882330",
                                  "19c713d48b7a4a8fa8f388f2cac66968",
        "a925fd669c9c4a53a14366e4d4a23961",
        "eee160e480cb452ebbb7d6e246dd071a",
        "2c583b57d4ee419fb337554dc3a7cdc7",
        "5194b97e0eb649ca8800ce8f04211e8e"];
      needSaveModuleIdList.forEach(item=>{
        if (this.templateInfo!=undefined && this.templateInfo.moduleid==item)
          this.isShowSaveBtn=true;
      })
    },

    //获取数据
    async initGrid() {
      console.log("homeview",this.homeCheckedBlkId,this.homepage_mgr)
      let drillObj = this.curDrillObj;
      let time = new Date();
      if(time-this.time<500) {
        return;
      }
      else{
        this.time = time;
      }
      console.log("initGrid",drillObj);
      if(this.$refs.tableControl != null) this.$refs.tableControl.loading = true;
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId == undefined) blkTypeId = "02";//01一期区块 02银行地质单元 03 计划区块
      this.curBlkTypeId = blkTypeId; //区块类型
      let that = this;
      console.log("11111111111111111111111111111111111");
      console.log("BB", this.$route.name)
      console.log("drillObj：", drillObj);
      let blockSelectWells = JSON.parse(localStorage.getItem("blockSelectWells"));
      console.log("blockSelectWells：", blockSelectWells);

      if (drillObj != undefined){
        if (drillObj.type == "1"){
          let drillid = ""
          for (let i = 0; i < drillObj.value.length; i++){
            drillid = drillid + "," + drillObj.value[i].id
          }
          that.drillJH = drillid.substring(1, drillid.length)
          that.drillBlock = "";
        } else if (drillObj.type == "0"){
          let drillQK = "";
          for (let i = 0; i < drillObj.value.length; i++) {
            drillQK = drillQK + "," + drillObj.value[i]
          }
          that.drillBlock = drillQK.substring(1, drillQK.length)
          that.drillJH = "";
          // console.log(666666666666666666666,  that.drillBlock);
          // 获取 区块id
          // that.drillBlock = drillObj.value[0].id;
        } else {
          that.drillBlock = "";
          that.drillJH = "";
          //添加记录单井
          if (blockSelectWells != undefined && blockSelectWells != null && blockSelectWells.length == 1)
            that.drillJH = blockSelectWells[0];
        }
      } else {
        that.drillBlock = "";
        that.drillJH = "";
        //添加记录单井
        if (blockSelectWells != undefined && blockSelectWells != null && blockSelectWells.length == 1)
          that.drillJH = blockSelectWells[0];
      }
      let checkedBlock = localStorage.getItem("checkedBlock");//左侧勾选区块信息
      console.log("checkedBlock：", checkedBlock);
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let strCheckedBlkId = "";//拼接左侧勾选区块id数据
      let keyIdx = 0;
      for (let key in jsonCheckedBlk) {
        if (keyIdx > 0) {
          strCheckedBlkId += ",";
        }
        strCheckedBlkId += key;
        keyIdx += 1;
      }
      if (this.homepage_mgr == "true") {
        console.log("aaaaaaaaaaaaaaaaaaaaaaa", this.homeCheckedBlkId);
        this.curCheckedBlkId = this.homeCheckedBlkId == "" ? strCheckedBlkId : this.homeCheckedBlkId;
        this.isDefaultTemplate=false;//todo 首页跳转，不知为什么默认等于 true，手动修改为 false
      } else {
        this.curCheckedBlkId = strCheckedBlkId;
      }
      // console.log("checkedblk:", strCheckedBlkId);
      this.gridCfg = {};
      this.theHeader = [];
      this.choseHeader = [];
      this.form.data = [];
      this.clickNum--;
      if (this.clickNum < 0) {
        this.clickNum = 0;
      }
      let _this = this;
      let user_id = "0000001";

      let token = localStorage.getItem("lyqtJwt");
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      //console.log("userinfo:",userInfoSession)
      // console.log(userInfoSession);
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_name = "";

      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // curUserId = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_name = jsonUserInfo.displayName;
        user_id = curUserEmplyeeId;
      }
      console.log('获取模块页面信息:');
      console.log(_this.templateInfo);
      if (_this.templateInfo.pageid == undefined) return;

      if(this.iswellGroup){
        await this.preSelectWellFunc();
        console.log("isWellGroup",this.relation_grupone_wells,this.relation_gruptwo_wells)
        console.log("isWellGroup",JSON.stringify(this.relation_grupone_wells),JSON.stringify(this.relation_gruptwo_wells))
      }
      //获取表头信息
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongridheader", {
        params: {
          user_id: user_id,
          app_id: _this.templateInfo.pageid,
          isDefaultTemplate: _this.isDefaultTemplate,
          configName:_this.configName,
          token: token
        }
      })
          .then(res => {
            console.log("初始化表头数据：", res)
            if (res.data.result=="failed"){
              ElMessage.info(res.data.message);
              this.$refs.tableControl.loading = false;
              return
            }
            this.gridCfg = res;
            this.choseHeader = res.data.template.checked;
            this.theHeader = res.data.template.header;
            this.form.name = res.data.template.title;
            this.form.dataSource = res.data.template.dataSource;
            this.form.dataAddress = res.data.template.dataAddress;
            this.setName = res.data.template.setName;
            this.configName = res.data.template.configName;
            this.form.isFixed = res.data.template.isFixed;
            this.form.isFixedNum = res.data.template.isFixedNum;
            this.form.operation = res.data.template.operation;
            this.form.pagination = 'pagination' in res.data.template ? res.data.template.pagination : true;
            this.form.dataSort.fieldStr = res.data.template.dataSort ? res.data.template.dataSort.fieldStr : "";
            this.form.dataSort.way = res.data.template.dataSort ? res.data.template.dataSort.way : "asc";
            this.form.dataSortName = res.data.template.dataSortName ? res.data.template.dataSortName : "暂无排序字段";
            this.form.pKey = res.data.template.pKey;
            this.queryFilter = res.data.queryFilter;
            this.isDefaultTemplate = res.data.isDefaultTemplate;
            this.unionConfig = res.data.unionConfig;
            console.log("this.form", _this.form);
            if (this.form.pagination==false && this.pageSize != 99999999)
              this.pageSize=99;
            //获取数据信息
            // console.log("看看有没有checkedBlk：",_this.curCheckedBlkId)
            if(this.templateInfo.type.indexOf('table_year')!=-1 || this.templateInfo.type.indexOf('table_mon')!=-1 || this.templateInfo.type.indexOf('table_day')!=-1 || this.isYear || this.isYearMonth || this.isYearMonDay || this.templateInfo.type.indexOf('table_enter_csj')!=-1)
            {
              this.selectTime();
            }
            else if(this.iswellGroup){
              this.queryGridData(true);
            }
            else {
              //处理区块选择组件的筛选条件
              let queryFilter=JSON.parse(JSON.stringify(this.queryFilter));
              // console.log("shshssssssssssssssssss3",blockQueryFilter)
              let blockQueryFilter=this.$store.state.blockQueryFilter;
              if (blockQueryFilter!=[] && blockQueryFilter.length!=0){
                if (queryFilter.length != 0) {
                  blockQueryFilter.logic = "AND";
                }
                queryFilter.push(blockQueryFilter);
              }
              if (queryFilter.length==0){
                queryFilter=[];
              }

              console.log("doWellDataClick1")
              this.wellDataClickWithoutRefresh();
              console.log("doWellDataClick3")
              axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddata",{
                user_id: user_id,
                user_empid: curUserEmplyeeId,
                user_name:user_name,
                app_id: _this.templateInfo.pageid,
                checkedBlk: _this.curCheckedBlkId,
                drillJH: _this.drillJH,
                drillBlock: _this.drillBlock,
                blkTypeID: _this.curBlkTypeId,
                queryFilter: queryFilter,
                total: true,//是否需要返回总页数
                page: this.currentPage,//当前页码从1开始
                size: this.pageSize,//一页显示记录数
                dataSort: this.form.dataSort,//当前排序字段
                isDefaultTemplate: this.isDefaultTemplate,
                configName:_this.configName,
                token: token,
                tableType: _this.templateInfo.type,
                wellOne:this.relation_grupone_wells,
                wellTwo:this.relation_gruptwo_wells,
                decimals:this.form.decimals,
              })
                  .then(res => {
                    this.form.data = [];
                    this.fromataCopy = [];
                    for (var dataIdx = 0; dataIdx < res.data.data.length; dataIdx++) {
                      _this.form.data.push(res.data.data[dataIdx]);
                      this.fromataCopy.push(res.data.data[dataIdx])
                      // if (dataIdx > 20) {
                      //   break;
                      // }
                    }
                    let jsons = {};
                    jsons.header = [];
                    for (var i in this.choseHeader) {
                      for (var j in this.theHeader) {
                        if (this.choseHeader[i] == this.theHeader[j].id) {
                          jsons.header.push(this.theHeader[j])
                        }
                      }
                    }
                    this.getManyHeader(jsons.header);
                    jsons.manyHeader = this.manyHeader;
                    jsons.isManyHeader = this.isManyHeader;

                    _this.form.dataNum = res.data.totalElements;
                    this.pageCount = Math.ceil(_this.form.dataNum / _this.pageSize);//解决分页显示出错
                    jsons.dataNum = _this.form.dataNum;
                    jsons.data = _this.form.data;
                    console.log("_this.form.data", _this.form.data)
                    jsons.clickNum = 0;
                    jsons.isFixed = _this.form.isFixed;
                    jsons.xxoo = _this.form.isFixedNum;
                    jsons.name = _this.form.name;
                    jsons.operation = _this.form.operation;
                    this.jsons = jsons;
                    console.log(jsons);
                    console.log("查询数据：", res);
                    console.log("_this.jsons+++++++++", _this.jsons,this.addTableDataList);
                    _this.$refs.tableControl.getData(_this.jsons);
                    _this.clickNum++;
                    if(this.$route.name === '6-1'){
                      this.enterMode();
                    }
                    else if(this.$route.name === '6-4' || this.$route.name === '6-5'){
                      this.enterMode();
                      this.entryType();
                      let tableDataCopy=JSON.parse(JSON.stringify(jsons.data));
                      console.log("_this.jsons",tableDataCopy)
                      for(let i=0; i<tableDataCopy.length; i++){
                        for(let j=0; j<jsons.header.length; j++){
                          console.log(jsons.header[j].COLUMN_NAME)
                          tableDataCopy[i][jsons.header[j].COLUMN_NAME] =tableDataCopy[i][jsons.header[j].COLUMN_NAME].value.name;
                        }
                      }
                      console.log("_this.jsons",tableDataCopy)
                      this.addTableDataList = tableDataCopy;
                    }
                    //if(drillObj == this.$store.state.drillObj) this.$store.state.drillObj= undefined;
                  }).catch(err => {
                console.log(err)
              })
            }
          }).catch(err => {
        console.log(err)
      })
      this.gridIsInited = true;

    },
    showPage(){
      this.form.pagination = true;
      this.viewTableControl = true;
      this.viewDisplay = true;
    },
    //获取预警单位列表
    getOrganizationList(){
      let url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData";
      axios.get(url)
          .then(res=>{
            this.organizationList=res.data;
          })
      console.log("23213123",this.organizationList)
    },
    // 右侧选中
    rightchange(value){
      let self = this
      self.item = value
      // if (this.dModuleManager == null){
      //获取右侧框勾选字段，作为排序字段保存
      // console.log(self.gridCfg.data.header)
      this.form.dataSort.fieldStr="";//清空排序字段内容
      this.form.dataSortName="暂无排序字段";//排序字段名称初始化
      //将勾选数据的对应内容赋值给 排序字段：dataSort与 排序字段名称：dataSortName
      for (let i=0;i<value.length;i++){
        for (let j = 0; j < self.theHeader.length; j++) {
          if (value[i] == self.theHeader[j].id) {
            if (i==0){
              self.form.dataSortName=self.theHeader[value[i]].COMMENTS;
              self.form.dataSort.fieldStr=self.theHeader[value[i]].COLUMN_NAME;
              // self.form.dataSortName=self.gridCfg.data.header[value[i]].COMMENTS;
              // self.form.dataSort.fieldStr=self.gridCfg.data.header[value[i]].COLUMN_NAME;
            }else {
              self.form.dataSortName=self.form.dataSortName +","+ self.theHeader[value[i]].COMMENTS;
              self.form.dataSort.fieldStr=self.form.dataSort.fieldStr +","+ self.theHeader[value[i]].COLUMN_NAME;
              // self.form.dataSortName=self.form.dataSortName +","+ self.gridCfg.data.header[value[i]].COMMENTS;
              // self.form.dataSort.fieldStr=self.form.dataSort.fieldStr +","+ self.gridCfg.data.header[value[i]].COLUMN_NAME;
            }
            break;
          }
        }
      }
      console.log(self.form.dataSort);
      console.log(self.form.dataSortName);
      // }
    },
    //开始拖拽
    drag(data){
      this.dropData = data
    },
    //结束拖拽
    drop(event){
      let targetText = "";
      if(event.toElement != undefined) targetText = event.toElement.innerText;
      if(event.target != undefined) targetText = event.target.innerText;
      if(targetText == "") return;

      let dropTo;
      for(let i in this.theHeader){
        if(this.theHeader[i].label == targetText){
          dropTo = this.theHeader[i].id;
          break
        }
      }
      let dropToIndex = this.choseHeader.indexOf(dropTo);
      let dropFormIndex = this.choseHeader.indexOf(this.dropData.id)
      let arr = JSON.parse(JSON.stringify(this.choseHeader))
      let item = arr.splice(dropFormIndex,1)
      arr.splice(dropToIndex,0,item[0])
      this.choseHeader = arr
      this.dropData = {}
    },
    // 上移事件
    handleUp(item,index) {
      // item为选中的项，index为对应的index
      let self = this;
      item = self.item;
      console.log(item)
      if (item.length == 1) {
        self.choseHeader.find((val, indexs) => {
          if (val == item) {
            index = indexs;
          }
        });
        if (index == 0) {
          //当选择的项的下标为0
          self.$message("已经移到顶部");
          return;
        }
        // 上移-改变的数组
        let changeItem = JSON.parse(JSON.stringify(self.choseHeader[index - 1]));
        self.choseHeader.splice(index - 1, 1);
        self.choseHeader.splice(index, 0, changeItem);
      } else {
        self.$message.error("只能选择一条数据上移");
        return;
      }
    },
    //下移
    handleDown (item, index) {
      let self = this;
      item = self.item;
      if (item.length == 1) {
        //选中值的下标
        self.choseHeader.find((val, indexs) => {
          if (val == item) {
            index = indexs;
          }
        });

        if (index == self.choseHeader.length - 1) {   // 这里是length-1,因为下标值从0开始
          self.$message("已经移到底部");
          return;
        }
        let changeItem = JSON.parse(JSON.stringify(self.choseHeader[index]));
        self.choseHeader.splice(index, 1);
        self.choseHeader.splice(index + 1, 0, changeItem);
      } else {
        self.$message.error("只能选择一条数据下移");
        return;
      }
    },
    //置顶
    handleTop(item, index) {
      // item为选中的项，index为对应的index
      let self = this;
      item = self.item;
      console.log(item)
      if (item.length == 1) {
        self.choseHeader.find((val, indexs) => {
          if (val == item) {
            index = indexs;
          }
        });
        if (index == 0) {
          //当选择的项的下标为0
          self.$message("已经移到顶部");
          return;
        }
        // 上移-改变的数组
        let changeItem = JSON.parse(JSON.stringify(self.choseHeader[index]));
        self.choseHeader.splice(index, 1);
        self.choseHeader.splice(0, 0, changeItem);
      } else {
        self.$message.error("只能选择一条数据上移");
        return;
      }
    },
    //置底
    handleButton(item, index) {
      let self = this;
      item = self.item;
      if (item.length == 1) {
        //选中值的下标
        self.choseHeader.find((val, indexs) => {
          if (val == item) {
            index = indexs;
          }
        });

        if (index == self.choseHeader.length - 1) {   // 这里是length-1,因为下标值从0开始
          self.$message("已经移到底部");
          return;
        }
        let length = self.choseHeader.length - 1
        let changeItem = JSON.parse(JSON.stringify(self.choseHeader[index]));
        self.choseHeader.splice(index, 1);
        self.choseHeader.splice(length, 0, changeItem);
      } else {
        self.$message.error("只能选择一条数据下移");
        return;
      }
    },
    //计算月度与年度指标考核实际值
    calcData(){
      if(this.templateInfo!=null){
        let startTime = "";
        let endTime = "";
        if (this.frameTimeType) {
          if (this.frameTimeSpot != null) {
            startTime = this.frameTimeSpot;
            endTime = this.frameTimeSpot;
          }
        }
        else{
          if (this.frameTime != null) {
            startTime = this.frameTime[0];
            endTime = this.frameTime[1];
          }
        }
        if(startTime == "" || endTime == ""){
          ElMessageBox("请先选择要计算的时间范围!");
          return;
        }
        if(this.curCheckedBlkId == null || this.curCheckedBlkId==undefined || this.curCheckedBlkId == ""){
          ElMessageBox("请选择要执行计算的管理区!");
          return;
        }
        axios.get(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/calcData",{params: {
            pageId: this.templateInfo.pageid,
            blkTypeId: this.curBlkTypeId,
            checkedBlk: this.curCheckedBlkId,
            beginDate: startTime,
            endDate: endTime
          }
        }).then(res=>{
          console.log(res);
          ElMessageBox(res.data.msg);
          if(res.data.success){
            this.initGrid();
          }
        }).catch(err=>{
          console.log(err);
        })
      }
    },
    //excel文件上传
    takeEx() {
      this.$refs.upload.click();
    },
    //excel文件上传
    takeExcelInfo() {
      this.myFiles = this.$refs.upload.files;
      if (this.isWork) {
        // this.$refs.workFileUploader.$el.uploadOk();

      } else {
        this.$refs.docFileUploader.uploadFile();
      }
    },
    //excel文件上传
    excel() {
      if (!this.$refs.upload.files) {
        return
      }
      let files = this.$refs.upload.files;
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        try {
          let data = e.target.result;
          const workbook = XLSX.read(data, {type: "binary"});
          let sheetNames = workbook.SheetNames;
          console.log("excelSheetNames:",sheetNames)
          let sheetName = sheetNames[0];
          let workSheet = workbook.Sheets[sheetName];
          console.log("mergebegin")
          workSheet = this.getExcelMergeData(workSheet);
          console.log("mergeEnd")
          let xlsData = XLSX.utils.sheet_to_json(workSheet);
          // console.log("excelMerge",this.getExcelMergeData(workSheet))
          let xlsHeader = [];
          let xlsHeaderList={};//记录数据表头信息，用于判断 xlsHeader 添加重复的表头数据
          for (let j = 0; j < xlsData.length; j++) {
            for (let i in xlsData[j]) {

              if(i.includes("日期")){
                if(this.isNumeric(xlsData[j][i])) {
                  xlsData[j][i] = this.getExcelDate(xlsData[j][i], "-");
                }
              }
              else if(i == "年月"){
                if(this.isNumeric(xlsData[j][i])) {
                  if(xlsData[j][i]-1<170001){
                    xlsData[j][i] = this.getExcelDate(xlsData[j][i], "").slice(0,6);
                  }
                }
              }else if(i == "年"){
                if(this.isNumeric(xlsData[j][i])) {
                  if(xlsData[j][i]-1>9999) {
                    xlsData[j][i] = this.getExcelDate(xlsData[j][i], "").slice(0, 4);
                  }
                }
              }

              if (!(i in xlsHeaderList) && i!="序号"){
                xlsHeader.push({
                  isPrimary: false,
                  to: "",
                  type: "string",
                  from: i,
                  label: i
                })
                xlsHeaderList[i]="";
              }
            }
          }
          xlsHeader.forEach(item => {
            console.log(item.from)//COMMENTS
            this.theHeader.forEach(Item => {
              if ("unitLabel" in Item && item.from == Item.unitLabel) {
                item.to = Item.COLUMN_NAME
              } else if (item.from == Item.COMMENTS) {
                console.log(Item.COMMENTS)
                item.to = Item.COLUMN_NAME
              }
            })
          })
          // let xlsHeaderNew = [];
          // for (let i=0;i<this.theHeader.length;i++){
          //   xlsHeaderNew.push({
          //     isPrimary: false,
          //     to: this.theHeader[i].COMMENTS,
          //     type: "string",
          //     from: "",
          //     label: this.theHeader[i].COMMENTS
          //   })
          // }
          // xlsHeaderNew.forEach(item=>{
          //   for (let j = 0; j < xlsData.length; j++) {
          //     for (let name in xlsData[j]) {
          //       if (item.to == name)
          //         item.from = name
          //     }
          //   }
          // })
          // xlsHeader=xlsHeaderNew;
          this.xlsData = xlsData;
          this.xlsHeader = xlsHeader;
          this.$refs.upload.value = "";
          this.importDialogVisible = true;
          console.log("1",xlsHeader)
          console.log("2",xlsData)
          console.log("3",this.theHeader)
        } catch {
          return false
        }
      }
      if (files.length != 0) {
        fileReader.readAsBinaryString(files[0])
      }
    },
    getExcelDate(excelTimestamp, format) {
      // 使用JavaScript转换unix时间戳需要将时间戳再*1000
      const old = excelTimestamp - 1
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60)
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear()
      const month = time.getMonth() + 1
      const date = time.getDate()
// 返回2022-12-02
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    getExcelMergeData(excelData){
      let mergeMap =  JSON.parse(JSON.stringify(excelData));
      const merges = excelData['!merges'];
      if(merges != undefined && merges != null) {
        merges.forEach(p => {
          let columnIndex = p['s']['c']
          const endColumn = p['e']['c']
          let rowIndex = p['s']['r']
          const endRow = p['e']['r']
          // const startColumn2 = String.fromCharCode(A+p['s']['c'])
          const startColumn = String.fromCharCode(65 + p['s']['c'])
          // const startColumn = p['s']['c']
          // console.log("startColumn",startColumn)
          const startRow = p['s']['r'] + 1
          while (columnIndex <= endColumn) {
            rowIndex = p['s']['r']
            // console.log("rowIndex",rowIndex)
            while (rowIndex <= endRow) {
              //       let column = String.fromCharCode('A' + columnIndex);
              let column = String.fromCharCode(65 + columnIndex);
              // let column = columnIndex;
              let row = rowIndex + 1
              // console.log("rowcol",row,column,xlsData)
              mergeMap[column + row] = excelData[startColumn + startRow]
              rowIndex++
            }
            columnIndex++
          }
        })
      }
      // console.log("mergeMap",mergeMap)
      // let xlsData = XLSX.utils.sheet_to_json(mergeMap);
      // console.log("mergeMap2",xlsData)
      return mergeMap;
    },
    //数据导入下拉监听
    dataChange(val) {
      let num = 0;
      let num1 = 0;
      console.log(val)
      for (let i in this.xlsHeader) {
        if (val == this.xlsHeader[i].from) {
          num++;
          console.log(this.xlsHeader)
          if (num > 1) {
            ElMessage("原字段不得重复")
            this.xlsHeader[i].from = "";
          }
        }
      }
      for (let i in this.xlsHeader) {
        console.log(this.xlsHeader[i])
        if (val == this.xlsHeader[i].to) {
          num1++;
          if (num1 > 1) {
            ElMessage("目标字段不得重复")
            this.xlsHeader[i].to = "";
          }
        }
      }
    },
    //数据导入更正
    dataModify() {
      console.log(this.xlsHeader)
      // console.log(this.xlsData)
      let xlsBody = {};
      xlsBody.header = [];
      xlsBody.data = [];
      let nowHeader = "";
      let nowData = "";
      for (let i in this.xlsHeader) {
        for (let j in this.xlsHeader[i]) {
          if (j == "isPrimary") {
            continue
          }
          if (this.xlsHeader[i][j] == "") {
            ElMessage("有未填写信息,请填写完毕后预览数据")
            return
          }
          if (j == "to") {
            for (let k in this.theHeader) {
              if (this.theHeader[k].COLUMN_NAME == this.xlsHeader[i][j]) {
                //console.log(this.theHeader[k])
                nowHeader = this.theHeader[k].COLUMN_NAME;
                let header = this.theHeader[k];
                header.type = this.xlsHeader[i].type
                xlsBody.header.push(header)
              }
            }
          }
          if (j == "from") {
            for (let k in this.theHeader) {
              if (this.theHeader[k].COLUMN_NAME == nowHeader) {
                nowData = this.theHeader[k].data
              }
            }
            // console.log(11,this.xlsHeader[i][j])
            // console.log(nowData)
            let title = JSON.parse(JSON.stringify(this.xlsHeader[i][j]))
            this.xlsData.forEach((item, index) => {
              if(title in item){
                item[nowData]=item[title]
                delete item[title];
              }
              this.xlsData[index] = item;
              // this.xlsData[index] = JSON.parse(JSON.stringify(item).replace(`${title}`, nowData))
            })
          }
        }
      }
      xlsBody.data = JSON.parse(JSON.stringify(this.xlsData))
      console.log(xlsBody)
      this.xlsBody = xlsBody;
      let arr = JSON.parse(JSON.stringify(this.xlsBody.data));
      let xls = arr.splice(0, this.xlsPageSize)
      this.xlsNow = xls;
      this.modifyDialogVisible = false;
    },
    //数据导入获取列类型
    getModifyType(data) {
      // console.log(this.xlsBody.header)
      let type = "";
      for (let i in this.xlsBody.header) {
        if (this.xlsBody.header[i].data == data) {
          // console.log(this.xlsBody.header[i])
          type = this.xlsBody.header[i].type
        }
      }
      return type
    },
    //数据导入修改值
    modifyChange() {
      console.log(this.xlsBody.data)
    },
    //双击表格触发——修改内容
    editData(row, column){
      row[column.property + "isShow"] = true;//显示编辑框
      this.$nextTick(() => {
        this.$refs[column.property] && this.$refs[column.property].focus(); //聚焦编辑框
      })
    },
    //编辑框失去焦点后触发，隐藏编辑框
    alterData (row, column) {
      row[column.property + "isShow"] = false;
      console.log(this.forecastTableData);
    },
    //数据导入修改提交
    modifyOk() {
      this.dataModify();
      console.log("body",this.xlsBody,this.theHeader)
      if(this.addTableDataList.length <= 0) {
        this.entryType();
      }
      for(let idx=0;idx<this.xlsBody.data.length;idx++)
      {
        let dataOne = {};
        this.theHeader.forEach(item => {
          let defaultVal = "";
          // if(item.COLUMN_NAME === 'LIC_BEGIN_DATE'){
          //   defaultVal = "2024-03-08"
          // }
          if (this.xlsBody.data[idx][item.COLUMN_NAME] != null && this.xlsBody.data[idx][item.COLUMN_NAME] != undefined) {
            defaultVal = this.xlsBody.data[idx][item.COLUMN_NAME];
          }
          dataOne[item.COLUMN_NAME] = defaultVal;
        })

        this.addTableDataList.push(dataOne);
      }
      this.importDialogVisible = false;
      // let now = new Date();
      // let y = now.getFullYear();
      // let m = now.getMonth()+1;
      // let d = now.getDate();
      // let h = now.getHours();
      // let mi = now.getMinutes();
      // let s = now.getSeconds();
      // m = m>9?m:"0"+m;
      // d = d>9?d:"0"+d;
      // h = h>9?h:"0"+h;
      // mi = mi>9?mi:"0"+mi;
      // s = s>9?s:"0"+s;
      // now = y+"-"+m+"-"+d+"|"+h+":"+mi+":"+s;
      // let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/record/add";
      // let token = localStorage.getItem("lyqtJwt");
      // let data = {};
      // data.pageId = this.templateInfo.pageid;
      // data.pageName = this.templateInfo.modulename;
      // data.datsrcName = "123";
      // data.dataUrl = this.form.dataSource;
      // data.header = this.xlsBody.header;
      // data.data = this.xlsBody.data;
      // data.authorization = token;
      // data.excelKey = this.excelKey;
      // data.uploadType="文件导入数据";
      // data.uploadTime = now;
      // axios.post(url, data)
      //     .then(res => {
      //       console.log(res)
      //       // ElMessage(res.data.msg)
      //       ElMessageBox(res.data.msg);
      //       this.modifyDialogVisible = false;
      //       this.importDialogVisible = false;
      //     })
    },
    //生成许可
    generateLic(){
      let userCodeSession = localStorage.getItem("licUserCode")
      if(this.$route.name !== '6-1'){
        if(this.$route.name === '6-5'){
          let params = {"unitInfo":this.addTableDataList, "userCode":userCodeSession};
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/saveUnitInfo",
            method:"PUT",
            headers: { "Content-Type": "application/json"},
            data: params,
            responseType: 'blob'
          }).then((res)=>{
            if(res.status === 200)
            {
              ElMessage.error('保存成功');
              this.$refs.tableControl.loading = false
            }
            else{
              ElMessage.error('保存失败');
              this.$refs.tableControl.loading = false
            }
          }).catch((err)=>{
            ElMessage.error('保存失败');
            this.$refs.tableControl.loading = false
            console.log(err);
          });
        }
        else if(this.$route.name === '6-4'){
          let params = {"productInfo":this.addTableDataList, "userCode":userCodeSession};
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/saveProductInfo",
            method:"PUT",
            headers: { "Content-Type": "application/json"},
            data: params,
            responseType: 'blob'
          }).then((res)=>{
            if(res.status === 200)
            {
              ElMessage.error('保存成功');
              this.$refs.tableControl.loading = false
            }
            else{
              ElMessage.error('保存失败');
              this.$refs.tableControl.loading = false
            }
          }).catch((err)=>{
            ElMessage.error('保存失败');
            this.$refs.tableControl.loading = false
            console.log(err);
          });
        }
        return;
      }
      let fileName = "error";
      this.$refs.tableControl.loading = true

      console.log("generaticDataList:",this.addTableDataList)
      for(let datIdx =0;datIdx<this.addTableDataList.length;datIdx++){
        let unitObj = this.licCustomUnit.unitMap[this.addTableDataList[datIdx].CUSTOMER_UNIT];
        if(unitObj == null || unitObj == undefined){
          ElMessage("存在不匹配的客户单位，请正确选择后再试！")
          return
        }
        this.addTableDataList[datIdx].CUSTOMER_UNIT_ID = unitObj.unitId
        this.addTableDataList[datIdx].CUSTOMER_ROOT_UNIT = unitObj.rootUnitName
        this.addTableDataList[datIdx].CUSTOMER_UNIT_NAME = unitObj.unitName

        let modeObj = this.licClass.modeMap[this.addTableDataList[datIdx].MODE_NAME];
        if(modeObj == null || modeObj == undefined){
          ElMessage("存在不匹配的许可类型，请正确选择后再试！")
          return
        }
        this.addTableDataList[datIdx].LIC_MODE_CODE = modeObj.modeCode

        let productObj = this.licProducts.productMap[this.addTableDataList[datIdx].GPT_PRODUCT_NAME];
        if(productObj == null || productObj == undefined){
          ElMessage("存在不匹配的产品名称，请正确选择后再试！")
          return
        }
        this.addTableDataList[datIdx].GPT_PRODUCT_ID = productObj.productId

        let productVersionObj = this.licProductVersionMap.productVersionMap[productObj.productId+this.addTableDataList[datIdx].GPT_VERSION];
        if(productVersionObj == null || productVersionObj == undefined){
          ElMessage("存在不匹配的产品版本号，请正确选择后再试！")
          return
        }
        this.addTableDataList[datIdx].GPT_VERSION_ID = productVersionObj.versionId

        if (typeof this.addTableDataList[datIdx].LIC_ENABLE_DAYS === 'string') {
          // 使用parseInt或者Number来转换字符串为数字
          this.addTableDataList[datIdx].LIC_ENABLE_DAYS = parseInt(this.addTableDataList[datIdx].LIC_ENABLE_DAYS, 10); // 或者使用 Number(maybeString.value)
        }
      }

      let params = {"licInfo":this.addTableDataList, "userCode":userCodeSession};
      console.log("导出", params);
      axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/generateLic",
        method:"POST",
        headers: { "Content-Type": "application/json"},
        data: params,
        responseType: 'blob'
      }).then((res)=>{
        console.log("download:",res)
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition) {
          const filenameRegex = /filename\*=UTF-8''(.+)$/; // 匹配编码后的文件名
          const matches = filenameRegex.exec(contentDisposition);
          if (matches && matches.length > 1) {
            // 解码文件名
            fileName = decodeURIComponent(matches[1]);
          }
        }
        console.log("downloadFileName:",fileName)
        if(res.status === 200 && fileName !== "error")
        {
          const content = res.data
          const blob = new Blob([content])
          const imageName = fileName;
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = imageName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, imageName)
          }
          this.$refs.tableControl.loading = false
        }
        else{
          ElMessage.error('下载文件失败');
          this.$refs.tableControl.loading = false
        }

      }).catch((err)=>{
        ElMessage.error('下载文件失败');
        this.$refs.tableControl.loading = false
        console.log(err);
      });
    },
    //数据上传分页
    xlsSizeChange(val) {
      let arr = JSON.parse(JSON.stringify(this.xlsBody.data))
      console.log(arr);
      let num = val * (this.xlsPage - 1) - 1;
      if (num < 0) {
        num = 0
      }
      let xls = arr.splice(num, val)
      this.xlsNow = xls;
    },
    //数据上传分页
    xlsCurrentChange(val) {
      let arr = JSON.parse(JSON.stringify(this.xlsBody.data))
      console.log(arr)
      let xls = arr.splice(val * this.xlsPageSize - 1, this.xlsPageSize)
      this.xlsNow = xls;
    },
    //数据上传删除
    handleDelete(index, raw) {
      console.log(index, raw)
      console.log(this.xlsData)
      this.xlsData.splice(index, 1)
    },
    delConfig() {
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_id = "0000001";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      let app_id = this.templateInfo.pageid;
      let switchConfigCame = this.switchConfigCame.replace("（用户）", "").replace("（公用）", "");//处理模板名称
      if (this.switchConfigCame.indexOf("（公用）") != -1)
        user_id = "0000001";
      axios.delete(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongridheader" + `?user_id=${user_id}&app_id=${app_id}&config_name=${switchConfigCame}`)
          .then(res => {
            console.log(res)
            ElMessage("配置删除成功")
            this.switchConfig();
          }).catch(err => {
        console.log(err)
      })
    },
    changeConfig() {
      if (this.switchConfigCame == this.configName || this.switchConfigCame == "defaultTemplate") {
        this.ddisable = true
      } else {
        this.ddisable = false
      }
    },
    //配置切换按钮
    switchConfig() {
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_id = "0000001";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      let app_id = this.templateInfo.pageid;
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/gridconfignames", {
        params: {
          user_id: user_id,
          app_id: app_id,
        }
      }).then(res => {
        console.log(res)
        this.configList = res.data.data;
        if (this.configList.length == 0) {
          ElMessage("暂无已保存的配置可供切换");
          return
        }

        this.switchConfigCame=this.configName;
        this.switchDialogVisible = true;
      })
    },
    //配置切换  确认按钮
    switchConfigOk() {
      console.log(this.switchConfigCame);
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_id = "0000001";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      let app_id = this.templateInfo.pageid;
      this.isDefaultTemplate = false;
      if (this.switchConfigCame == "defaultTemplate")
        this.isDefaultTemplate = true;
      this.isPublicConfig = false;
      if (this.switchConfigCame.indexOf("（公用）") != -1) {
        this.isPublicConfig = true;
        user_id = "0000001";
      }
      axios.put(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddataconfig", {
        user_id: user_id,
        app_id: app_id,
        config_name: this.switchConfigCame,
      }).then(res => {
        console.log("切换",res);
        this.configName=this.switchConfigCame;
        this.initGrid();
      });
      this.switchDialogVisible = false;
    },
    clickSaveAsConfig() {
      this.saveName = "";
      this.isPublicConfig=false;
      this.saveDialogVisible = true;
    },
    //保存配置
    saveConfig() {
      //使用系统模板保存时，需重新填写名称
      if (this.setName != "" && !this.isDefaultTemplate) {
        this.doSaveConfig(this.setName);
      } else {
        this.saveDialogVisible = true;
      }
    },
    saveConfigOk() {
      if (this.dModuleManager != null) {
        this.doSaveConfig(this.saveName);
        return;
      }
      //当前数据库中无用户配置时，直接保存
      console.log("setName:",this.setName);
      if (this.setName == "") {
        this.doSaveConfig(this.saveName);
        return;
      }
      //确定是否重名覆盖
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_id = "0000001";
      if (userInfoSession.length > 0 && this.isPublicConfig==false) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      let app_id = this.templateInfo.pageid;
      let _this = this;
      console.log(app_id);
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/gridconfig", {
        user_id: user_id,
        app_id: app_id,
        config_name: this.saveName
      }).then(res => {
        //找到配置，确定覆盖
        if (res.data.result == "success") {
          ElMessageBox.confirm(
              '配置名称已存在，是否确定覆盖?',
              '提醒',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }
          )
              .then(() => {
                _this.doSaveConfig(_this.saveName);
              })
              .catch(() => {

              })
        } else {
          //未找到配置，直接保存
          _this.doSaveConfig(_this.saveName);
        }
      });
    },
    doSaveConfig(name) {
      //系统配置模块
      // console.log("保存时的模板信息", this.templateInfo);
      if (this.dModuleManager != null) {
        this.dModuleManager.template = [{
          dataSource: this.form.dataSource,
          title: this.form.name,
          setName: name,
          header: this.theHeader,
          checked: this.choseHeader,
          isFixed: this.form.isFixed,
          isFixedNum: this.form.isFixedNum,
          operation: this.form.operation
        }]
        console.log("保存时的模板信息", this.form);
        this.dialogVisible = false;
        return;
      }
      //表格配置
      if (name == "") {
        ElMessage("配置名称不得为空")
        return
      }
      let _this = this;
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_id = "0000001";
      if (userInfoSession.length > 0 && this.isPublicConfig==false) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/savecommongridheader", {
        app_id: this.templateInfo.pageid,
        user_id: user_id,
        config_name: name,//this.setName,
        dataSource: _this.form.dataSource,
        dataAddress: _this.form.dataAddress,
        title: this.form.name,
        setName: name,//_this.setName,
        header: this.theHeader,
        checked: this.choseHeader,
        isFixed: this.form.isFixed,
        isFixedNum: this.form.isFixedNum,
        operation: this.form.operation,
        pagination: this.form.pagination,
        dataSort: this.form.dataSort,
        dataSortName:this.form.dataSortName,
        pageid:this.pageid,
        unionConfig:this.unionConfig,
      }).then(res => {
        console.log("保存配置", res)
        ElMessage("配置保存成功")
        _this.saveDialogVisible = false;
        // _this.setName = _this.saveName;
        _this.setName = name;
      })
    },
    //点击表格配置数据源下拉框
    dataSourceChange(val) {
      console.log(val)
      this.theHeader = [];
      this.choseHeader = [];
      this.form.dataSortName = "暂无排序字段";
      this.form.dataSort = {
        fieldStr:"",
        way:"asc",
      };
      for (let i in this.dataSource) {
        if (this.dataSource[i].DATSRC_ID == val) {
          //this.theHeader=this.dataSource[i].TABLE_COLUMNS;
          console.log(this.form,this.dataSource[i]);
          this.form.dataAddress=this.dataSource[i].DATAURL;//选择不同数据源时，将选中将数据地址信息 记录
          for (let j in this.dataSource[i].HEAD) {
            this.theHeader.push(this.dataSource[i].HEAD[j])
            this.theHeader[j].label = this.dataSource[i].HEAD[j].COMMENTS;
            this.theHeader[j].isFixed = null;
            this.theHeader[j].edit = false;
            this.theHeader[j].data = this.dataSource[i].HEAD[j].COLUMN_NAME;
          }
        }
      }
    },
    //是否可编辑切换
    editChange() {
      if (this.drillValue.edit == true) {
        delete this.drillValue.router
      }
    },

    //钻取选择下拉框节点触发
    onSelectPage(node) {
      console.log(node);
      let that = this;
      that.page = {}
      that.page.pageid = node.pageid;
      that.page.seq = node.seq;
      that.page.label = node.label;
      that.page.pid = node.pid;
      that.page.lev = node.lev;
      that.page.isLeaf = node.isLeaf;
      that.page.type = node.type;
      that.page.route = node.route;
      that.page.template = []
      that.drillValue.drillname = node.label;
      that.drillValue.router = node.pageid;
      that.drillValue.type = node.type;
    },
    //钻取切换
    selectChange() {
      if (this.drillValue.router != undefined || this.drillValue.router != "") {
        this.drillValue.edit = false;
      }
      setTimeout(() => {
        this.$refs.multiSelect.blur()
      }, 50)

    },
    //钻取下拉清除按钮
    clearDrill() {
      this.drillValue.edit = false;
      delete this.drillValue.router
    },
    //钻取页面确认
    drillChoseOk() {
      if (this.drillValue.router == "") {
        delete this.drillValue.router
      }
      for (var i = 0; i < this.theHeader.length; i++) {
        if (this.theHeader[i].id == this.drillValue.id) {
          let dd = JSON.parse(JSON.stringify(this.drillValue));
          if(this.isNumeric(this.drillValue.colWidth)){
            dd.WIDTH = parseFloat(this.drillValue.colWidth);
          }
          this.theHeader[i] = dd;
        }
      }
      this.drillDialogVisible = false;
    },
    isNumeric(value){
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    //打开钻取
    isDrill(option) {
      console.log("drilloption",option)
      this.isDrillOnlyShowOther = false;
      if(option.COLUMN_NAME !=undefined){
        if(option.COLUMN_NAME.toUpperCase() != "JH" && option.COLUMN_NAME.toUpperCase() != "WELL_COMMON_NAME")
          this.isDrillOnlyShowOther = true;
      }
      let id = option.id;
      let isShow = true;
      for (let i in this.choseHeader) {
        if (id == this.choseHeader[i]) {
          isShow = false;
        }
      }
      if (isShow) {
        return
      }

      let d = JSON.parse(JSON.stringify(option))
      this.drillValue = d;
      if (this.drillValue.router == undefined) {
        this.drillValue.router = '';
      }
      if(this.isNumeric(id)){
        let choseHeaderObj = this.theHeader[id];
        if(this.isNumeric(choseHeaderObj.WIDTH)) {
          this.drillValue.colWidth = choseHeaderObj.WIDTH;
        }
      }
      this.drillDialogVisible = true;
    },
    //是否冻结
    isFixedChange() {
      if (this.form.isFixed == false) {
        this.form.isFixedNum = 0;
      }
    },
    //切换所展示的列触发
    choseChange(value, where, arr) {
      this.form.isFixed = false;
      console.log(value, where, arr);
      if (where == 'left') {
        for (let itemm in arr) {
          console.log(arr[itemm])
          for (let i = 0; i < this.theHeader.length; i++) {
            if (this.theHeader[i].id == arr[itemm]) {
              console.log(this.theHeader[i])
              delete this.theHeader[i].router
              console.log(this.theHeader[i])
            }
          }
        }
      }
      if (this.choseHeader.length < this.form.isFixedNum) {
        this.form.isFixedNum = 0;
      }
    },
    //触行表格控件选择列的选择事件
    onSelectColumnStatusChanged(val) {
      this.curSelRowArray = val;
      console.log("当前选中行是-view：", this.curSelRowArray);
    },
    onShowRoute(type,url,name,docShowIframeUrl){
      console.log(type,url)
      console.log(name,docShowIframeUrl)
      switch (type) {
        case "img":
          this.routeImgUrl = url;
          this.routeImgType = type;
          break;
        case "gmp":
          this.routeImgUrl = url;
          this.routeImgType = type;
          break;
        case "doc":
          this.docShowIframeUrl = docShowIframeUrl;
          this.routeImgType = type;
          docShow(url, name);
          break;
      }
    },
    // 触发送审按钮--测试接口，已弃用
    // sendToBank() {
    //   let _this = this;
    //   ElMessageBox.prompt('请输入送审说明', '数据应用问题提交银行', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     inputErrorMessage: '无效的输入',
    //   })
    //       .then(({value}) => {
    //         if (this.curSelRowArray.length <= 0) {
    //           ElMessage.warning("未勾选任何送审记录，请勾选后重试！");
    //           return;
    //         }
    //         let selRowIdList = [];
    //         for (let rowIdx = 0; rowIdx < this.curSelRowArray.length; rowIdx++) {
    //           // console.log(this.curSelRowArray[rowIdx]);
    //           selRowIdList.push(this.curSelRowArray[rowIdx]["id"].value);
    //         }
    //         // console.log(selRowIdList);
    //         //获取用户信息
    //         let userInfoSession = localStorage.getItem("lyqtUserInfo");
    //         if (userInfoSession == null) userInfoSession = {};
    //
    //         let curUserId = "";
    //         let curUserEmplyeeId = "";
    //         if (userInfoSession.length > 0) {
    //           let jsonUserInfo = JSON.parse(userInfoSession);
    //           curUserId = jsonUserInfo.userId;
    //           curUserEmplyeeId = jsonUserInfo.employeeId;
    //         }
    //         console.log("uuuus:", curUserId, curUserEmplyeeId);
    //         axios({
    //           url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/sendProblemListToBank",
    //           method: 'POST',
    //           data: {"ids": selRowIdList, "userid": curUserId, "sendRemark": value}
    //         }).then(async (res) => {
    //           if (res.status === 200) {
    //             let resp = res.data;
    //             console.log("sendVerify", resp);
    //             ElMessage.success("数据已送交银行处理，敬待处理结果！");
    //             _this.initGrid();
    //           }
    //         }).catch((err) => {
    //           ElMessage('Error');
    //           console.log(err);
    //         })
    //       })
    //       .catch(() => {
    //         console.log("取消送审！")
    //       })
    // },
    //触发考核综合治理方案审核按钮
    doSchemeVerifyOp() {
      let _this = this;
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/approval";

      //获取用户信息
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage.warning("无法获取当前用户信息，无法送审，请登录后重试！");
        return;
      }
      if (this.curSelRowArray.length <= 0) {
        ElMessage.warning("未勾选任何送审记录，请勾选后重试！");
        return;
      }
      if(_this.assessSchemeVerifyForm.verifyRemark.length == 0)
      {
        ElMessage.warning("审核意见未填，无法提交，请填写后重试！");
        return;
      }
      // if(_this.assessSchemeVerifyForm.verifyScore == 0)
      // {
      //   ElMessage.warning("注意！评分为0分！");
      //   //return;
      // }
      let selRowIdList = [];
      let statusVal="";
      for (let rowIdx = 0; rowIdx < this.curSelRowArray.length; rowIdx++) {
        if(statusVal.length==0)
          statusVal = this.curSelRowArray[rowIdx][_this.checkSelectablefield].value;
        else if(statusVal != this.curSelRowArray[rowIdx][_this.checkSelectablefield].value)
        {
          ElMessage.warning("批量审核操作对应的审核阶段必须全同相同，请检查后重试！");
          return;
        }
        selRowIdList.push(this.curSelRowArray[rowIdx]["id"].value);
      }
      let warningStr = "当前勾选的送审记录将由您完成审核操作，提交后无法辙回，是否确认？";
      if(statusVal=="待初审")
      {
        if(_this.assessSchemeVerifyForm.verifyResult == "通过") {
          warningStr = "当前勾选的送审记录将由您完成初审，提交后无法辙回，是否确认？";
        }
        else {
          warningStr = "当前勾选的送审记录将由您驳回，提交后无法辙回，是否确认？";
        }
      }
      else if(statusVal=="待终审")
      {
        if(_this.assessSchemeVerifyForm.verifyResult == "通过") {
          warningStr = "当前勾选的送审记录将由您完成终审，提交后无法辙回，是否确认？";
        }
        else {
          warningStr = "当前勾选的送审记录将由您驳回，提交后无法辙回，是否确认？";
        }
      }
      ElMessageBox.confirm(warningStr, '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            let jsonUserInfo = JSON.parse(userInfoSession);
            let sendDat = {};
            sendDat["ids"] = selRowIdList;
            if(this.dataScreenApproval){
              sendDat["ids"] = [];
              this.curSelRowArray.forEach(item=>{
                sendDat.ids.push(item.id.value)
              })
            }
            sendDat["userid"] = jsonUserInfo.userId;
            sendDat["userempid"] = jsonUserInfo.employeeId;
            sendDat["username"] = jsonUserInfo.displayName;
            sendDat["moduleid"] = _this.templateInfo.moduleid;
            if(this.dataScreenApproval){
              sendDat["moduleid"] = "dataScreeningReview"
            }
            if(this.uploadApproval){
              sendDat["moduleid"] = "uploadDocumentReview"
            }
            sendDat["jwt"] = jwtSession;
            sendDat["verifyRemark"] = _this.assessSchemeVerifyForm.verifyRemark;
            sendDat["verifyResult"] = _this.assessSchemeVerifyForm.verifyResult;
            sendDat["verifyCnt"] = _this.assessSchemeVerifyForm.verifyCnt;
            sendDat["verifyScore"] = _this.assessSchemeVerifyForm.verifyScore;
            sendDat["qualityCount"] = _this.assessSchemeVerifyForm.qualityCount;
            console.log(sendDat)
            axios({
              url: url ,
              method: 'POST',
              data: sendDat
            }).then(async (res) => {
              if (res.status === 200) {
                let resp = res.data;
                console.log("sendVerify", resp);
                ElMessage.success("审核信息已提交！");
                _this.assessSchemeverifyDlgVisible = false;
                _this.initGrid();
              }
            }).catch((err) => {
              ElMessage('信息提交失败，请联系管理员或稍后重试！');
              console.log(err);
            })
          })
          .catch(() => {
            console.log("取消！")
          })
    },
    //触发审核按钮
    doVerifyOp() {
      let _this = this;
      let url = _this.doVerifyUrl;
      let nextOpUserStr = "";
      if(this.dataScreenApproval){
        url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/check/approval";
      }else if(this.uploadApproval){
        url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/audit/approval";
        this.curSelAuditer.forEach(item=>{
          if(nextOpUserStr!="") nextOpUserStr+=";";
          nextOpUserStr+=item.empid
        })
      }
      //获取用户信息
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage.warning("无法获取当前用户信息，无法送审，请登录后重试！");
        return;
      }
      if (this.curSelRowArray.length <= 0) {
        ElMessage.warning("未勾选任何送审记录，请勾选后重试！");
        return;
      }
      if(_this.verifyForm.verifyRemark.length == 0)
      {
        ElMessage.warning("审核意见未填，无法提交，请填写后重试！");
        return;
      }
      let selRowIdList = [];
      let statusVal="";
      for (let rowIdx = 0; rowIdx < this.curSelRowArray.length; rowIdx++) {
        if(statusVal.length==0)
          statusVal = this.curSelRowArray[rowIdx][_this.checkSelectablefield].value;
        else if(statusVal != this.curSelRowArray[rowIdx][_this.checkSelectablefield].value)
        {
          ElMessage.warning("批量审核操作对应的审核阶段必须全同相同，请检查后重试！");
          return;
        }
        selRowIdList.push(this.curSelRowArray[rowIdx]["id"].value);
      }
      let warningStr = "当前勾选的送审记录将由您完成审核操作，提交后无法辙回，是否确认？";
      if(statusVal=="待初审")
      {
        if(_this.verifyForm.verifyResult == "通过" || _this.verifyForm.verifyResult == 1) {
          warningStr = "当前勾选的送审记录将由您完成初审，提交后无法辙回，是否确认？";
        }
        else {
          warningStr = "当前勾选的送审记录将由您驳回，提交后无法辙回，是否确认？";
        }
      }
      else if(statusVal=="待终审")
      {
        if(_this.verifyForm.verifyResult == "通过" || _this.verifyForm.verifyResult == 1) {
          warningStr = "当前勾选的送审记录将由您完成终审，提交后无法辙回，是否确认？";
        }
        else {
          warningStr = "当前勾选的送审记录将由您驳回，提交后无法辙回，是否确认？";
        }
      }
      ElMessageBox.confirm(warningStr, '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            let jsonUserInfo = JSON.parse(userInfoSession);
            let sendDat = {};
            sendDat["ids"] = selRowIdList;
            if(this.dataScreenApproval){
              sendDat["ids"] = [];
              this.curSelRowArray.forEach(item=>{
                sendDat.ids.push(item.id.value)
              })
            }
            sendDat["userid"] = jsonUserInfo.userId;
            sendDat["userempid"] = jsonUserInfo.employeeId;
            sendDat["username"] = jsonUserInfo.displayName;
            sendDat["moduleid"] = _this.templateInfo.moduleid;
            sendDat["nextOpUsers"] = nextOpUserStr;
            if(this.dataScreenApproval){
              sendDat["moduleid"] = "dataScreeningReview"
            }
            // if(this.uploadApproval){
            //   sendDat["moduleid"] = "uploadDocumentReview"
            // }
            sendDat["jwt"] = jwtSession;
            sendDat["verifyRemark"] = _this.verifyForm.verifyRemark;
            sendDat["verifyResult"] = _this.verifyForm.verifyResult=="通过"||_this.verifyForm.verifyResult==1?"通过":"驳回";
            console.log(sendDat)
            axios({
              url: url ,
              method: 'POST',
              data: sendDat
            }).then(async (res) => {
              if (res.status === 200) {
                let resp = res.data;
                console.log("sendVerify", resp);
                ElMessage.success("审核信息已提交！");
                _this.verifyDlgVisible = false;
                _this.auditUserList = [];
                _this.initGrid();
              }
            }).catch((err) => {
              ElMessage('信息提交失败，请联系管理员或稍后重试！');
              console.log(err);
            })
          })
          .catch(() => {
            console.log("取消！")
          })
    },
    //数据甄别送审
    dataScreenSubmit(){
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage({
          type: '错误',
          message: '无法获取当前用户信息，无法送审，请登录后重试！',
        })
        return;
      }
      let jsonUserInfo = JSON.parse(userInfoSession);
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/check/submit";
      let data = {};
      data.jwt = localStorage.getItem("lyqtJwt");
      data.moduleid = this.templateInfo.moduleid;
      data.userid = jsonUserInfo.userId;
      data.userempid = jsonUserInfo.employeeId;
      data.username = jsonUserInfo.displayName;
      data.ids = [];
      this.curSelRowArray.forEach(item=>{
        data.ids.push(item.datarecordId.value)
      })
      axios.post(url,data)
          .then(res=>{
            console.log(res)
            ElMessage.success("数据送审成功");
            this.initGrid();
          })
    },
    //数据上传送审
    uploadSubmit(){
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage({
          type: '错误',
          message: '无法获取当前用户信息，无法送审，请登录后重试！',
        })
        return;
      }
      let jsonUserInfo = JSON.parse(userInfoSession);
      // let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/audit/submit";
      let data = {};
      data.jwt = localStorage.getItem("lyqtJwt");
      data.moduleid = this.templateInfo.moduleid;
      data.userid = jsonUserInfo.userId;
      data.userempid = jsonUserInfo.employeeId;
      data.username = jsonUserInfo.displayName;
      data.ids = [];
      console.log(this.curSelRowArray)
      if(this.curSelRowArray.length>1){
        ElMessageBox("多记录送审流程正在进行调整，请先单记录送审!")
        return
      }
      this.curSelRowArray.forEach(item=>{
        data.ids.push(item.documentuploadId.value)
      });
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/audit/nextSubmitOPUser",data)
          .then(res=>{
            if(res.data.success){
              this.auditUserList = res.data.content;
              this.auditUserSelDialogVisible = true;
              this.$nextTick(()=>{
                this.$refs.auditerTable.toggleAllSelection();
              },100)
              console.log(this.auditUserList)
            }
          })
      // axios.post(url,data)
      //     .then(res=>{
      //       console.log(res)
      //       ElMessage.success("数据送审成功");
      //       this.initGrid();
      //     })
    },
    doUploadApproval(){
      if(!this.uploadApproval) return;
      let _this = this;
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/audit/nextApprovalOPUser";

      //获取用户信息
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage.warning("无法获取当前用户信息，无法审核，请登录后重试！");
        return;
      }
      if (this.curSelRowArray.length <= 0) {
        ElMessage.warning("未勾选任何审核记录，请勾选后重试！");
        return;
      }
      let selRowIdList = [];
      let statusVal="";
      for (let rowIdx = 0; rowIdx < this.curSelRowArray.length; rowIdx++) {
        if(statusVal.length==0)
          statusVal = this.curSelRowArray[rowIdx][_this.checkSelectablefield].value;
        else if(statusVal != this.curSelRowArray[rowIdx][_this.checkSelectablefield].value)
        {
          ElMessage.warning("批量审核操作对应的审核阶段必须全同相同，请检查后重试！");
          return;
        }
        selRowIdList.push(this.curSelRowArray[rowIdx]["id"].value);
      }

      let jsonUserInfo = JSON.parse(userInfoSession);
      let sendDat = {};
      sendDat["ids"] = selRowIdList;
      if(this.dataScreenApproval){
        sendDat["ids"] = [];
        this.curSelRowArray.forEach(item=>{
          sendDat.ids.push(item.id.value)
        })
      }
      sendDat["userempid"] = jsonUserInfo.employeeId;
      sendDat["moduleid"] = _this.templateInfo.moduleid;
      // if(this.uploadApproval){
      //   sendDat["moduleid"] = "uploadDocumentReview"
      // }
      sendDat["jwt"] = jwtSession;
      axios({
        url: url ,
        method: 'POST',
        data: sendDat
      }).then(async (res) => {
        if (res.status === 200) {
          let resp = res.data;
          if(resp.success){
            this.auditUserList =resp.content;
            this.verifyDlgVisible = true;
            if(this.auditUserList.length>0) {
              this.$nextTick(() => {
                this.$refs.auditerAprovalTable.toggleAllSelection();
              }, 100)
            }
            console.log(this.auditUserList)
          }
        }
      }).catch((err) => {
        ElMessageBox('获取用户信息失败，请联系管理员或稍后重试！');
        console.log(err);
      })

    },
    handleAuditerSelChange(val){
      this.curSelAuditer = val;
    },
    doUploadSubmitWithUserList(nextAuditUser){
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
        userInfoSession = {};
        ElMessage({
          type: '错误',
          message: '无法获取当前用户信息，无法送审，请登录后重试！',
        })
        return;
      }
      let jsonUserInfo = JSON.parse(userInfoSession);
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/audit/submit";
      let data = {};
      data.jwt = localStorage.getItem("lyqtJwt");
      data.moduleid = this.templateInfo.moduleid;
      data.userid = jsonUserInfo.userId;
      data.userempid = jsonUserInfo.employeeId;
      data.username = jsonUserInfo.displayName;
      data.ids = [];
      data.nextOpUsers = nextAuditUser;
      console.log(this.curSelRowArray)
      if(this.curSelRowArray.length>1){
        ElMessageBox("多记录送审流程正在进行调整，请先单记录送审!")
        return
      }
      this.curSelRowArray.forEach(item=>{
        data.ids.push(item.documentuploadId.value)
      });
      axios.post(url,data)
          .then(res=>{
            console.log(res)
            ElMessage.success("数据送审成功");
            this.initGrid();
          })
    },

    //触发送审按钮
    sendToVerify() {
      let _this = this;
      ElMessageBox.confirm('当前勾选的数据将送审并进入审核流程，送审后数据不可修改和删除，是否确认送审？', '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warring',
      })
          .then(() => {
            if (this.curSelRowArray.length <= 0) {
              ElMessage.warning("未勾选任何送审记录，请勾选后重试！");
              return;
            }
            let selRowIdList = [];
            for (let rowIdx = 0; rowIdx < this.curSelRowArray.length; rowIdx++) {
              console.log(this.curSelRowArray[rowIdx]);
              if (Object.prototype.hasOwnProperty.call(this.curSelRowArray[rowIdx],"ID")) {
                if (Object.prototype.hasOwnProperty.call(this.curSelRowArray[rowIdx]["ID"].value,"name")) {
                  selRowIdList.push(this.curSelRowArray[rowIdx]["ID"].value.name);
                }
                else{
                  selRowIdList.push(this.curSelRowArray[rowIdx]["ID"].value);
                }
              }
              else{
                selRowIdList.push(this.curSelRowArray[rowIdx]["id"].value);
              }
            }
            // console.log(selRowIdList);
            //获取用户信息
            let userInfoSession = localStorage.getItem("lyqtUserInfo");
            let jwtSession = localStorage.getItem("lyqtJwt");
            if (userInfoSession == null || userInfoSession.length <= 0 || jwtSession == null || jwtSession.length <= 0) {
              userInfoSession = {};
              ElMessage({
                type: '错误',
                message: '无法获取当前用户信息，无法送审，请登录后重试！',
              })
              return;
            }

            // if (userInfoSession.length > 0) {
            let jsonUserInfo = JSON.parse(userInfoSession);
            let sendDat = {};
            sendDat["ids"] = selRowIdList;
            sendDat["userid"] = jsonUserInfo.userId;
            sendDat["userempid"] = jsonUserInfo.employeeId;
            sendDat["username"] = jsonUserInfo.displayName;
            sendDat["moduleid"] = _this.templateInfo.moduleid;
            sendDat["tempInfo"] = _this.templateInfo;
            sendDat["jwt"] = jwtSession;
            // }
            // console.log("uuuus:", sendDat);
            this.problemCheckData = [];
            this.problemCheckDialog = false;
            axios({
              url: this.sendVerifyCheckUrl,
              method: 'POST',
              data: sendDat
            }).then(async (res) => {
              let resp = res.data;
              console.log(res);
              if (resp.success) {
                //送审操作
                axios({
                  url: this.sendtoVerifyUrl,
                  method: 'POST',
                  data: sendDat
                }).then(async (res) => {
                  if (res.status === 200) {
                    let resp = res.data;
                    console.log("sendVerify", resp);
                    if(resp.success){
                      ElMessage.success("数据已送审，敬待处理结果！");
                      _this.initGrid();
                    }
                    else{
                      ElMessage.error(resp.message);
                    }
                  }
                }).catch((err) => {
                  ElMessage('Error');
                  console.log(err);
                })
              }
              else {
                this.problemCheckDialog = true;
                this.problemCheckData = resp.content;
              }
            }).catch((err) => {
              ElMessage('Error');
              console.log(err);
            })
          })
          .catch(() => {
            console.log("取消送审！")
          })
    },
    //监听查询
    numChange(data){
      this.queryConfigNum.num1=data.num1;
      this.queryConfigNum.num2=data.num2;
      console.log(this.queryConfigNum)
    },
    //触发查询按钮
    refresh(){
      this.refreshDialogVisible=true;
      console.log(this.queryFilter.length)
      let num1 = 0;
      let num2 = 0;
      let arr1 = [];
      let arr2 = [];
      for(let i in this.queryFilter){
        arr2.push(this.queryFilter[i].code)
        for(let j in this.queryFilter[i].children){
          arr1.push(this.queryFilter[i].children[j].code)
        }
      }
      arr1=arr1.sort()
      arr2=arr2.sort()
      num1=arr1[arr1.length-1];
      num2=arr2[arr2.length-1];
      console.log(num1,num2)
      this.$nextTick(()=>{
        this.$refs.queryConfig.queryFilter = this.queryFilter;
        this.$refs.queryConfig.num1 = num1;
        this.$refs.queryConfig.num2 = num2;
      },100)
    },
    //查询条件置空
    refreshReset(){
      this.$refs.queryConfig.queryFilter=[{
        code:0,//组别唯一序列号
        logic:"",//与其他组别的关系
        show:false,//折叠状态
        children:[{
          logic:"",//逻辑
          field:"",//字段
          symbol:"",//条件
          value:"",//值
          code:0//条件唯一序列号
        }],
      }];
      this.$refs.queryConfig.num1=1;
      this.$refs.queryConfig.num2=1;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_id =curUserEmplyeeId;
      }
      if (this.configName.indexOf("（公用）") != -1)
        user_id = "0000001";
      this.queryFilter = [];
      if (!this.isDefaultTemplate){
        //保存筛选条件
        axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongridfilter",{
          app_id:this.templateInfo.pageid,
          curUserEmplyeeId:curUserEmplyeeId,
          user_id:user_id,
          config_name:this.setName,
          queryFilter:[]
        }).then(res=>{
          console.log("保存过滤条件",res)
          // ElMessage("过滤条件保存成功")
        });
      }
      this.queryGridData(true);
    },
    //查询页面点击提交
    refreshOk(){
      let queryFilter = this.$refs.queryConfig.queryFilter;
      queryFilter[0].logic="";
      for(let i in queryFilter){
        for(let j in queryFilter[i].children){
          for(let k in queryFilter[i].children[j]){
            //console.log(k+"="+queryFilter[i].children[j][k])
            if(queryFilter[i].children[j][k]===""){
              if(j==0&&k=="logic"){
                continue
              }else{
                ElMessage("您有未填写查询条件,请补全后再提交")
                return
              }
            }
          }
        }
      }
      console.log(queryFilter);
      // console.log(this.homepage_mgr!=null);
      // //如果从首页筛选，则不保存;使用系统配置模板时也不需要保存
      // if (this.homepage_mgr==null && !this.isDefaultTemplate){
      //   console.log("保存筛选条件========")
      //   let user_id = "0000001";
      //   let userInfoSession = localStorage.getItem("lyqtUserInfo");
      //   if (userInfoSession == null) userInfoSession = {};
      //   // let curUserId = "";
      //   let curUserEmplyeeId = "";
      //   if (userInfoSession.length > 0) {
      //     let jsonUserInfo = JSON.parse(userInfoSession);
      //     // user_id = jsonUserInfo.userId;
      //     curUserEmplyeeId = jsonUserInfo.employeeId;
      //     user_id = curUserEmplyeeId;
      //   }
      //   //保存筛选条件
      //   axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongridfilter",{
      //     app_id:this.templateInfo.pageid,
      //     user_id:user_id,
      //     curUserEmplyeeId: curUserEmplyeeId,
      //     config_name:this.setName,
      //     queryFilter:queryFilter
      //   }).then(res=>{
      //     console.log("保存情况",res)
      //     ElMessage("过滤条件保存成功")
      //   });
      // }
      this.queryFilter = queryFilter;
      this.queryGridData(true);
      this.refreshDialogVisible = false;
    },
    //触发子组件导出功能
    file() {
      let wellName=this.$store.getters.getWellData[0]!=undefined && this.$store.getters.getWellData[0]!=null ? this.$store.getters.getWellData[0] : "";
      this.$refs.tableControl.$data.fileName = wellName + this.templateInfo.modulename;
      this.$refs.tableControl.files();
    },
    //打开配置页面
    async config() {
      //报表模块打开时，退出等待
      if (this.dataUsrTree == null && this.dModuleManager == null) {
        ElMessage("数据加载中，请稍等");
        return
      }
      //其他模块调用时，同步加载
      if (this.dataUsrTree == null && this.dModuleManager != null) {
        ElMessage.success("数据加载中，请稍等");
        await this.gettableSource();
      }
      this.dialogVisible = true;
    },
    // 获取 获取页面配置的 表格配置模板
    initConfig(pageid) {
      if(this.dModuleManager != null){
        axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/pagetemplate",{
          pageid: pageid
        }).then(res=>{
          console.log("获取表格数据：",res.data);
          if(res.data.result == "success") {
            let header=res.data.template.header;
            let checked=res.data.template.checked;
            let newChoseHeader=[];//重新获取已选择的列 集合
            //剔除checked中多余的内容；  存在一种情况：数据源修改后，表头数据更改，导致数据库中已保存的cheked信息可能会出现与表头信息不匹配的情况，使页面查询数据时会报错
            for (let i = 0; i < header.length; i++) {
              // console.log(checked.indexOf(header[i].id), header[i].id);
              if (checked.indexOf(header[i].id) != -1)
                newChoseHeader.push(header[i].id);
            }
            console.log("choseHeader:",newChoseHeader);
            this.choseHeader = newChoseHeader;
            this.theHeader = header;
            this.form.name = res.data.template.title;
            this.form.dataSource = res.data.template.dataSource;
            this.setName = res.data.template.setName;
            this.form.isFixed=res.data.template.isFixed;
            this.form.isFixedNum=res.data.template.isFixedNum;
            this.form.operation=res.data.template.operation;
            this.form.dataSort.fieldStr=res.data.template.dataSort?res.data.template.dataSort.fieldStr:"";
            this.form.dataSort.way=res.data.template.dataSort?res.data.template.dataSort.way:"asc";
            this.form.dataSortName=res.data.template.dataSortName?res.data.template.dataSortName:"暂无排序字段";
          }
        }).catch(err=>{
          console.log(err)
        })
      }
    },
    //配置页面确定按钮
    configOk() {
      let _this = this;
      let json = {};
      json.xxoo = -1;
      if (this.form.name == "") {
        ElMessage("请输入标题")
        return
      }
      json.name = this.form.name;
      if (this.choseHeader.length == 0) {
        ElMessage("请选择要展示的列")
        return
      }
      if (this.form.isFixed == true) {
        if (this.form.isFixedNum == 0) {
          json.xxoo = -1;
        } else {
          json.xxoo = this.form.isFixedNum;
        }
      }
      json.header = [];

      this.choseHeader.forEach(item => {
        for (let i = 0; i < this.theHeader.length; i++) {
          if (this.theHeader[i].id == item) {
            json.header.push(this.theHeader[i])
          }
        }
      })
      // 钻取确认并更改后 重新加载table
      if(_this.drillValue.router != null){
        this.$refs.tableControl.loading = true;
      }

      //根据排序中文名称设置排序字段名称
      console.log("json:",json);
      console.log("dModuleManager:",this.dModuleManager);
      if (this.dModuleManager != null) {
        this.saveName = this.form.name;
        this.saveConfigOk();
        // _this.templateInfo.moduleid = this.dModuleManager.moduleid;
      }
      else {
        if (this.form.pagination == false)
          this.pageSize = 99;
        else
          this.pageSize = 20;
        this.queryGridData(true);
      }
    },

    afterUpload(response) {
      console.log(response);
      if(this.upload_status==1){
        this.initGrid();
      }else{
        this.excelKey = response;
        this.excel()
      }

    },
    //每页展示条数切换
    sizeChange(pageSize){
      console.log(pageSize)
      let num = this.form.dataNum/pageSize;
      this.pageCount=Math.ceil(num);
      this.pageSize = pageSize;
      this.queryGridData(false);
    },
    //点击第几页
    currentChange(currentPage){
      console.log(currentPage)
      this.currentPage=currentPage;
      this.queryGridData(false);
    },
    queryGridData(needTotal){
      let drillObj = this.curDrillObj;
      // let time = new Date();
      // if(time-this.time<500)
      // {
      //   if(drillObj == undefined) return;
      // }
      // else{
      //   this.time = time;
      // }
      console.log("queryGridDrill",drillObj);
      this.loading=true;
      let that = this;
      let blockSelectWells = JSON.parse(localStorage.getItem("blockSelectWells"));
      console.log("blockSelectWells：", blockSelectWells);
      if (drillObj != undefined) {
        if (drillObj.type == "1") {
          let drillid = ""
          for (let i = 0; i < drillObj.value.length; i++) {
            drillid = drillid + "," + drillObj.value[i].id
          }
          that.drillJH = drillid.substring(1, drillid.length)
          that.drillBlock = "";
        } else if (drillObj.type == "0") {
          let drillQK = ""
          for (let i = 0; i < drillObj.value.length; i++) {
            drillQK = drillQK + "," + drillObj.value[i]
          }
          that.drillBlock = drillQK.substring(1, drillQK.length)
          that.drillJH = "";
          // console.log(666666666666666666666,  that.drillBlock);
          // 获取 区块id
          // that.drillBlock = drillObj.value[0].id;
        } else {
          that.drillBlock = "";
          that.drillJH = "";
          //添加记录单井
          if (blockSelectWells != undefined && blockSelectWells != null && blockSelectWells.length == 1)
            that.drillJH = blockSelectWells[0];
        }
      } else {
        that.drillBlock = "";
        that.drillJH = "";
        //添加记录单井
        if (blockSelectWells != undefined && blockSelectWells != null && blockSelectWells.length == 1)
          that.drillJH = blockSelectWells[0];
      }
      this.viewSelectionWell=false;
      this.$refs.tableControl.loading = true;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let token = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      let user_name = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_name = jsonUserInfo.displayName;
        user_id = curUserEmplyeeId;
      }
      let queryFilter=[];

      //处理查询语句，选择时间后，将时间条件拼接上
      queryFilter=JSON.parse(JSON.stringify(this.queryFilter));
      if (this.frameQueryFilter!=null) {
        if (queryFilter.length!=0){
          this.frameQueryFilter.logic = "AND";
        }
        queryFilter.push(this.frameQueryFilter);
      }
      let blockQueryFilter=this.$store.state.blockQueryFilter;
      // console.log("shshssssssssssssssssss2",blockQueryFilter)
      if (blockQueryFilter!=[] && blockQueryFilter.length!=0){
        if (queryFilter.length != 0) {
          blockQueryFilter.logic = "AND";
        }
        queryFilter.push(blockQueryFilter);
      }

      let grupOneName = '井组1';
      let grupTwoName = '井组2';
      for(let grupIdx=0;grupIdx<this.relation_grup_list.length;grupIdx++){
        if(this.relation_grup_list[grupIdx].value == this.relation_grupone_name){
          grupOneName = this.relation_grup_list[grupIdx].label;
        }
        if(this.relation_grup_list[grupIdx].value == this.relation_gruptwo_name){
          grupTwoName = this.relation_grup_list[grupIdx].label;
        }
      }
      console.log("queryFiter:",queryFilter,JSON.stringify(this.relation_grupone_wells),JSON.stringify(this.relation_gruptwo_wells))
      this.wellDataClickWithoutRefresh();
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddata", {
        user_id: user_id,
        user_empid: curUserEmplyeeId,
        user_name:user_name,
        dataAddress: this.form.dataAddress,
        app_id: this.templateInfo.pageid,
        checked: this.choseHeader,
        header: this.theHeader,
        blkTypeID: this.curBlkTypeId,
        checkedBlk: this.curCheckedBlkId,
        dataSort:this.form.dataSort,
        drillJH: that.drillJH,
        drillBlock: that.drillBlock,
        token: token,
        queryFilter: queryFilter,//查询条件
        total: needTotal,//是否需要返回总页数
        page: this.currentPage,//当前页码从1开始
        size: this.pageSize,//一页显示记录数
        wellOne:this.relation_grupone_wells,
        wellTwo:this.relation_gruptwo_wells,
        wellOneName:grupOneName,
        wellTwoName:grupTwoName,
        tableType:this.templateInfo.type,
        decimals:this.form.decimals,
        isDefaultTemplate: this.isDefaultTemplate,
        configName:this.configName,
      }).then(res => {
        console.log("点击分页", res.data.data)
        this.form.data = res.data.data;
        let json = {};
        json.clickNum = 0;
        // json.header=this.theHeader;
        json.header = [];
        for (var i in this.choseHeader) {
          for (var j in this.theHeader) {
            if (this.choseHeader[i] == this.theHeader[j].id) {
              json.header.push(this.theHeader[j])
            }
          }
        }
        this.getManyHeader(json.header);
        json.manyHeader = this.manyHeader;
        json.isManyHeader = this.isManyHeader;
        json.name = this.form.name;
        json.operation = this.form.operation;
        json.xxoo = this.form.isFixedNum;
        json.data = res.data.data;
        this.jsons = json;
        console.log("query_this.jsons+++++++++", this.jsons);
        if (needTotal) {
          this.form.dataNum = res.data.totalElements;
          this.pageCount = Math.ceil(res.data.totalElements / this.pageSize);//解决分页显示出错
        }
        this.jsons = json;
        this.$refs.tableControl.getData(this.jsons);
        // this.wellDataClick();
        this.dialogVisible = false;
        //if(drillObj == this.$store.state.drillObj) this.$store.state.drillObj= undefined;
      }).catch(err => {
        console.log(err)
      })
      this.dialogVisible = false;
    },

    //另存系统配置
    clickSaveSystemConfig(){
      this.isPublicConfig=false;
      this.pageid=this.templateInfo.pageid;
      console.log(this.pageid);
      this.doSaveConfig("defaultTemplate");
      this.pageid = "";
    },
    //另存公用配置
    clickSavepublicConfig(){
      this.isPublicConfig = true;
      this.saveDialogVisible = true;
    },
    //点击选井按钮
    clickSelectionWell(){
      this.viewSelectionWell = true;
      this.preSelectWellFunc();
    },
    async preSelectWellFunc(){
      await this.getUserBlockData();

      //获取区块o类型
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId == undefined) blkTypeId = "02";//01一期区块 02银行地质单元 03 计划区块

      if(blkTypeId=="04"){//井组则自动设置当前选定井组
        let checkedBlock = localStorage.getItem("checkedBlock");//左侧勾选区块信息
        if (checkedBlock == null) {
          checkedBlock = {};
        }
        let jsonCheckedBlk;
        try {
          jsonCheckedBlk = JSON.parse(checkedBlock);
        } catch {
          jsonCheckedBlk = JSON.parse("{}");
        }

        let grupIdx = 0;
        for (let grupID in jsonCheckedBlk) {
          if (grupIdx == 0) {
            this.relation_grupone_name = grupID
            await this.onRelationGroupOneChange(grupID);
          }
          else if(grupIdx == 1){
            this.relation_gruptwo_name = grupID
            await this.onRelationGroupTwoChange(grupID);
          }
          else{
            break;
          }
          grupIdx += 1;
        }
      }
      else{
        if(this.wellgroupOneData.length == 0) this.wellgroupOneData=this.$store.getters.getWellgroupData;
        if(this.wellgroupTwoData.length == 0) this.wellgroupTwoData=this.$store.getters.getWellgroupData;
      }
    },
    //切换系统配置
    switchSystemConfig(){
    },

    //勾选排序按钮
    checkSort() {
      console.log(0)
    },
    //获取勾选井组1—关联井数据
    handleWellCheckOne(currentNode, checkedObjs) {
      let wellGrupOneData=[];
      let checkednodes = checkedObjs.checkedNodes;
      for (let nodeIdx in checkedObjs.checkedNodes)
      {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children){
          //获取井名称
          wellGrupOneData.push(data.label);
        }
      }
      this.relation_grupone_wells = wellGrupOneData;
      console.log("wellGrupOneData:",this.relation_grupone_wells);
    },

    //获取勾选井组2—关联井数据
    handleWellCheckTwo(currentNode, checkedObjs){
      let wellGrupTwoData=[];
      let checkednodes = checkedObjs.checkedNodes;
      for (let nodeIdx in checkedObjs.checkedNodes)
      {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children){
          //获取井名称
          wellGrupTwoData.push(data.label);
        }
      }
      this.relation_gruptwo_wells = wellGrupTwoData;
      console.log("wellGrupTwoData:",this.relation_gruptwo_wells);
    },
    //选则时间段后触发
    selectTime() {

      console.log(1111112316,this.isYear,this.isYearMonth,this.isYearMonDay);
      console.log(this.templateInfo.type);
      console.log(this.templateInfo);
      if(this.templateInfo!=null) {//判断考核是否可以编辑
        this.isKHModule = false;
        let moduleIdStr = this.templateInfo.moduleid;
        if(moduleIdStr == 'c78575952fec411883148e6965517135' || moduleIdStr == 'a2ecb45de2844e02a1ecad12165a55c4'){
          this.isKHModule = true;
        }
        this.isZBGZModule = false;
        if(moduleIdStr == 'c1b3d60a41134c85bdba239413882330'
            || moduleIdStr == '19c713d48b7a4a8fa8f388f2cac66968'
            || moduleIdStr == 'eee160e480cb452ebbb7d6e246dd071a'
            || moduleIdStr == 'a925fd669c9c4a53a14366e4d4a23961'
        ){
          this.isZBGZModule = true;
        }
        this.isZBFXModule = false;
        if(moduleIdStr == '2c583b57d4ee419fb337554dc3a7cdc7'
            || moduleIdStr == '2602248D46BF4FEB80DC35AE113FF1C5'
            || moduleIdStr == '5194b97e0eb649ca8800ce8f04211e8e'
        ){
          this.isZBFXModule = true;
        }
        let startTime = "";
        let endTime = "";
        if (this.frameTimeType) {
          if (this.frameTimeSpot != null) {
            startTime = this.frameTimeSpot;
            endTime = this.frameTimeSpot;
          }
        } else {
          if (this.frameTime != null) {
            startTime = this.frameTime[0];
            endTime = this.frameTime[1];
          }
        }
        if(startTime==undefined) startTime = "";
        if(endTime == undefined) endTime = "";
        console.log("hehe",startTime,endTime)
        axios.get(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/isEnableKHUpload", {
          params: {
            moduleID: this.templateInfo.pageid,
            DateMode: this.isYear||this.templateInfo.type=='table_year'?"year":"yearmon",
            beginDate: startTime,
            endDate: endTime
          }
        }).then(res => {
          this.isKhEnableUpload = res.data.success;
        }).catch(err => {
          console.log(err);
          this.isKhEnableUpload = false;
        })
      }
      //判断是否为年月日模式
      let isDayMode = this.isYearMonDay || (this.templateInfo.type!=null && this.templateInfo.type.indexOf('table_day')!=-1)
      //let fieldMap = {};
      //fieldMap["79678F5533B64994AEEF7BAB64C0C3EF"] = "PROD_DATE";
      let dayFieldStr = "YEAR_MON";
      if(this.templateInfo.moduleid == "79678F5533B64994AEEF7BAB64C0C3EF" || this.templateInfo.moduleid == '0A8171C316E94441E0632E034F0A7E52') dayFieldStr = "PROD_DATE";
      if(this.templateInfo.moduleid == "8AD2AB0E29E6468A887125053BC2B6F7" || this.templateInfo.moduleid == '0A8171C316E84441E0632E034F0A7E52') dayFieldStr = "INJ_DATE";
      if(this.templateInfo.moduleid == "E53C0A0041864DE7B6C93E1113779355" || this.templateInfo.moduleid == '0A8171C316EA4441E0632E034F0A7E52') dayFieldStr = "INJ_DATE";
      let rqFieldStr = isDayMode? dayFieldStr : "YEAR_MON";
      // let rqFieldStr = "YEAR_MON";

      let isEmpty = true;//选择空时间标识， true：空时间，false：时间不为空
      let queryFilter = {
        code: 0,//组别唯一序列号
        logic: "",//与其他组别的关系
        show: false,//折叠状态
        children: [],
      };
      let children = {
        logic: "",//逻辑
        field: "",//字段
        symbol: "",//条件
        value: "",//值
        code: 0//条件唯一序列号
      };
      //选择时间点，选择时间段
      if (this.frameTimeType) {
        console.log(this.frameTimeSpot);
        if (this.frameTimeSpot != null) {
          isEmpty = false;
          children.value = this.frameTimeSpot;
          children.field = rqFieldStr;
          children.symbol = "=";
          queryFilter.children.push(children);
        }
      } else {
        console.log(this.frameTime);
        if (this.frameTime != null) {
          isEmpty = false;
          children.value = this.frameTime[0];
          children.field = rqFieldStr;
          children.symbol = ">=";
          queryFilter.children.push(children);
          let childrenTemp = JSON.parse(JSON.stringify(children))
          childrenTemp.code = 1;
          childrenTemp.logic = "AND";
          childrenTemp.value = this.frameTime[1];
          childrenTemp.field = rqFieldStr;
          childrenTemp.symbol = "<=";
          queryFilter.children.push(childrenTemp);
        }
      }
      this.frameQueryFilter = queryFilter;
      if (isEmpty) {
        this.frameQueryFilter = null;
      }
      console.log(this.frameQueryFilter);
      this.queryGridData(true);
    },

    //时间选择（年度）——开始日期限定条件
    disabledDateStart(time) {
      return this.frameYear.endTime!=null ? time.getFullYear() >= this.frameYear.endTime : false;
    },
    //时间选择（年度）——结束日期限定条件
    disabledDateEnd(time) {
      return time.getFullYear() <= this.frameYear.startTime;
    },
    //时间选择（年月）——开始日期限定条件
    disabledFrameMonStart(time) {
      //返回 ：true：禁止选择，fasle：允许选择
      return this.frameYear.endTime != null ? moment(time).format("YYYYMM")>=this.frameYear.endTime :false;
    },
    //时间选择（年月）——结束日期限定条件
    disabledFrameMonEnd(time) {
      return moment(time).format("YYYYMM") <= this.frameYear.startTime;
    },
    //时间选择（年月日）——开始日期限定条件
    disabledFrameDayStart(time) {
      //返回 ：true：禁止选择，fasle：允许选择
      return this.frameYear.endTime != null ? moment(time).format("YYYY-MM-DD")>=this.frameYear.endTime :false;
    },
    //时间选择（年月日）——结束日期限定条件
    disabledFrameDayEnd(time) {
      return moment(time).format("YYYY-MM-DD") <= this.frameYear.startTime;
    },
    //获取当前系统时间,mode 0-年 1-月 2-日  preTage，向前推进时间，单位与mode一致
    getNowDate(mode,preTage){
      let date = new Date();
      let year = date.getFullYear();
      if(mode == 0)
      {
        date.setFullYear(year-preTage);
        return date.getFullYear().toString();
      }
      let mon = date.getMonth();
      if(mode == 1)
      {
        date.setMonth(mon-preTage);
        year = date.getFullYear();
        mon = date.getMonth();
        if(mon>=1 && mon <=9) mon = "0"+mon;
        return year+""+mon;
      }
      if(mode == 2){
        let day = date.getDate();
        date.setDate(day-preTage);
        year = date.getFullYear();
        mon = date.getMonth()+1;
        day = date.getDate();
        if(mon>=1 && mon <=9) mon = "0"+mon;
        if(day>=1 && day <=9) day = "0"+day;
        return year+"-"+mon+"-"+day;
      }
      return "";
    },

    //综合整理考核——新增
    assessAdd(){
      this.isAssessAdd=true;
      let lyqtUserInfo=JSON.parse(localStorage.lyqtUserInfo);//获取登录用户信息
      this.assessFromData.submitter=lyqtUserInfo.displayName;//默认填写提交人
      this.assessFromData.submission_time=new Date().toLocaleString();//默认获取提交时间
    },
    //综合整理考核——新增——上传附件
    assessUpload(){
      this.myFiles=this.$refs.assessAnnex.input.files;

      // console.log(this.$refs.assessAnnex.input.files);
      console.log(this.assessFromData.annex);
      console.log(this.myFiles);

    },
    //综合整理考核——新增——确认
    assessAddOk(){
      console.log(this.assessFromData);
      // console.log(this.$refs.assessFrom);
      //表单验证函数，验证不通过则退出
      let isValid=false;
      this.$refs.assessFrom.validate(valid =>{
        console.log(valid)
        isValid=valid;
      })
      if (!isValid){
        ElMessage("请完善信息！")
        return
      }
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/assessAddData",{"assessFromData":this.assessFromData}).then(res=>{
        console.log(res.data);
        ElMessage.success("添加成功！");
      }).catch(err=>{
        console.log(err);
      });
      this.isAssessAdd=false;
      this.initGrid();//刷新数据
    },
    //综合整理考核——发布
    assessRelease(){
      let len=this.curSelRowArray.length;
      if (len==0){
        ElMessage("请选择需要发布的考核记录！")
        return
      }
      let releaseData=[];//封装对应的发布信息
      let lyqtUserInfo=JSON.parse(localStorage.lyqtUserInfo);//获取登录用户信息
      let dateTime=new Date().toLocaleString();//默认获取发布时间
      for (let i=0;i<len;i++){
        let data={};
        data.ID=this.curSelRowArray[i].ID.value["name"];
        data.PUBLISHER=lyqtUserInfo.displayName;
        data.RELEASE_TIME=dateTime;
        releaseData.push(data);
      }
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/assessRelease",{"releaseData":releaseData}).then(res=>{
        console.log(res);
        ElMessage.success("已发布")
      }).catch(err=>{
        console.log(err);
      })
      this.initGrid();//刷新数据
    },

    //树形下拉框返回值
    getValue(value){
      this.form.dataSource=value;
      this.dataSourceChange(value);
    },


    //数据送审按钮（完成情况数据，指标分析页面）
    indexDataUpload(){
      console.log(this.templateInfo);
      if (this.jsons.data.length==0){
        ElMessage.info("无数据，不能送审");
        return
      }
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/indexUpload/dataUpload";
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      let data = {};
      data.pageId = this.templateInfo.pageid;
      data.moduleid = this.templateInfo.moduleid;
      data.pageName = this.templateInfo.modulename;
      data.dataUrl = this.form.dataSource;
      data.jsons = this.jsons;
      data.authorization = token;
      data.uploadType = "table";
      axios.post(url,data).then(res=>{
        console.log(res)
        ElMessage.success(res.data.message)
      })
    },

    //删除记录——上传类页面
    deleteRecordUpload(){
      let len=this.curSelRowArray.length;
      console.log(this.curSelRowArray)
      if (len==0){
        ElMessage("请选择需要删除的上传记录！")
        return
      }
      let recordIds="";//拼接记录id
      let lyqtUserInfo=JSON.parse(localStorage.lyqtUserInfo);//获取登录用户信息

      for (let i=0;i<len;i++){
        if(this.upload_type.length>0) {
          recordIds += this.curSelRowArray[i].id.value + ",";
        }
        else if(this.templateInfo.pageid == "8643efc26459411582de36cb71c7c938"){
          recordIds += this.curSelRowArray[i].documentuploadId.value + ",";
        }
      }

      recordIds=recordIds.substring(0,recordIds.length-1);
      axios.post(process.env.VUE_APP_SERVER + "/fileprocesser/deleteRecordUpload", {
        "recordIds": recordIds,
        "upload_type": this.upload_type.length >0?this.upload_type:this.templateInfo.pageid,
        "lyqtUserInfo": lyqtUserInfo,
      }).then(res => {
        console.log(res);
        ElMessage.success(res.data.message);
      }).catch(err => {
        console.log(err);
      })
      this.initGrid();//刷新数据
    },

    //保存修改报表数据
    saveEditTabeleData(){
      if(this.editTableList.length>0 && (this.isZBGZModule || this.isZBFXModule)){
        let addTableDataList = [];
        for(let editDatIdx=0; editDatIdx<this.editTableList.length; editDatIdx++){
          let editCurRowDat = this.editTableList[editDatIdx] != null?this.editTableList[editDatIdx].editData:{};

          let dataOne = {};
          this.theHeader.forEach(item => {
            dataOne[item.COLUMN_NAME] = editCurRowDat[item.COLUMN_NAME] == null ? "":editCurRowDat[item.COLUMN_NAME];
          })
          addTableDataList.push(dataOne);
        }

        console.log(addTableDataList);
        if (addTableDataList.length==0){
          ElMessage.info("无可保存数据！");
          return;
        }
        let now = new Date();
        let y = now.getFullYear();
        let m = now.getMonth()+1;
        let d = now.getDate();
        let h = now.getHours();
        let mi = now.getMinutes();
        let s = now.getSeconds();
        m = m>9?m:"0"+m;
        d = d>9?d:"0"+d;
        h = h>9?h:"0"+h;
        mi = mi>9?mi:"0"+mi;
        s = s>9?s:"0"+s;
        now = y+"-"+m+"-"+d+"|"+h+":"+mi+":"+s;
        let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/record/addYYRecord";
        let token = localStorage.getItem("lyqtJwt");
        let data = {};
        data.pageId = this.templateInfo.pageid;
        data.pageName = this.templateInfo.modulename;
        data.dataUrl = this.form.dataSource;
        data.header = this.theHeader;
        data.data = addTableDataList;
        data.authorization = token;
        data.uploadType="录入数据";
        data.uploadTime = now;
        console.log("data:",data)
        console.log("form:",this.form)
        axios.post(url, data).then(res => {
          console.log(res)
          ElMessage.success(res.data.msg);
          if (res.data.success){
            this.editTableList=[];//清空添加数据列表
            // this.viewTableControl=true;//显示查询数据报表
            this.initGrid();//刷新数据
          }
        }).catch(err=>{
          console.log(err)
        })
        return;
      }
      console.log(this.editTableList);
      let lyqtUserInfo=JSON.parse(localStorage.lyqtUserInfo);//获取登录用户信息
      let dateTime=new Date().toLocaleString();//默认获取发布时间
      console.log(lyqtUserInfo);//displayName
      console.log(dateTime);
      console.log(this.form);//dataAddress,dataSource,name
      console.log(this.theHeader);
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/saveEditTabeleData",{
        tableName:this.form.name,
        dataAddress:this.form.dataAddress,
        dataSource:this.form.dataSource,
        pKey:this.form.pKey,
        userName:lyqtUserInfo.displayName,
        dateTime:dateTime,
        data:this.editTableList
      }).then(res => {
        console.log(res);
        ElMessage.success(res.data.message);
        if (res.data.success==true){
          this.editTableList=[];
          this.initGrid();//刷新数据
        }
      }).catch(err => {
        console.log(err);
      })
    },
    //返回是否需要响应wellDataClick的判断结果
    getWellDataClickBool(){
      let result = true;
      console.log("wellDataBool1",result);
      if(this.$store.state.isJump){
        this.$store.state.isJump = false;
        result = false;
        console.log("wellDataBool2",result);
      }
      if(this.$store.state.isWarDriing == 1) {
        this.$store.state.isWarDriing = 0;
        result = false;
        console.log("wellDataBool3",result);
      }
      if(this.wellDataClickNum > 0){
        result = false;
        console.log("wellDataBool4",result);
      }
      if(this.$store.getters.getWellData.length <1){
        result = false;
        console.log("wellDataBool5",result);
      }
      console.log("wellDataBool6",result);
      return result;
    },
    //研究井位点击
    wellDataClick(){
      console.log(this.$store.state.isJump,this.wellDataClickNum)
      this.getWellDataClickBool();
      this.wellDataClickNum ++
      this.homepage_mgr = null;
      if(this.$store.getters.getWellData.length ==1){
        // let drillObj = {};
        // drillObj.type = 1;
        // drillObj.value = [{
        //   id: this.$store.getters.getWellData[0],
        //   text: this.$store.getters.getWellData[0]
        // }];
        // this.$store.state.isJump = false;
        // this.$store.state.drillObj = drillObj;
        console.log("走了吗getWellData!", this.$store.getters.getWellData)
      }else{
        if(this.curDrillObj != undefined){
          if(!this.homepage_mgr) {
            this.curDrillObj = undefined;
          }
          // this.initGrid();
        }
      }
    },
    //研究井位点击
    wellDataClickWithoutRefresh(){
      console.log(this.$store.state.isJump,this.wellDataClickNum)
      this.getWellDataClickBool();
      this.wellDataClickNum ++
      // this.homepage_mgr = null;//有病啊？设置为null
      if(this.$store.getters.getWellData.length ==1){
        // let drillObj = {};
        // drillObj.type = 1;
        // drillObj.value = [{
        //   id: this.$store.getters.getWellData[0],
        //   text: this.$store.getters.getWellData[0]
        // }];
        // this.$store.state.isJump = false;
        // this.noRefreshDrillObj = true;
        // this.$store.state.drillObj = drillObj;
        console.log("走了吗getWellData!", this.$store.getters.getWellData)
      }else{
        if(this.curDrillObj != undefined){
          if(!this.homepage_mgr){
            this.curDrillObj = undefined;//不明所以，为啥设置，
          }
        }
      }
    },

    //点击录入按钮（数据录入功能）
    enterMode(){
      console.log("kjknmknjnjbn")
      console.log(this.theHeader)
      console.log(this.choseHeader)
      this.viewTableControl=!this.viewTableControl;
      if(this.$route.name === '6-1') {
        axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getlicInfo").then(res=>{
          console.log(res);
          this.licProducts          = res.data.content.licProducts;               //许可-产品名称
          this.licProductVersionMap = res.data.content.licProductVersionMap;      //许可-产品版本字典
          this.licClass             = res.data.content.licClass;                  //许可类型 正式 临时
          this.licCustomUnit        = res.data.content.licCustomUnit;             //客户归属单位 [中石油]***油田
          this.licSQDate            = res.data.content.licSQDate;                 //申请日期
          this.licConfig         = res.data.content.licConfig;              //许可最大申请数

          // this.licMaxEnableDays     = res.data.content.licMaxEnableDays;          //许可最大有效天数


        }).catch(err=>{
          console.log(err);
        })
        return;
      }
      //第一次点击加载措施类型数据
      if (JSON.stringify(this.cslxSelectObj)!="{}")
        return
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getTorStat").then(res=>{
        console.log(res);
        this.cslxSelectObj=res.data.content;
      }).catch(err=>{
        console.log(err);
      })
    },
    //点击添加按钮（数据录入功能）
    addTableData() {
      this.entryType();
      let dataOne = {};
      this.theHeader.forEach(item => {
        let defaultVal = "";
        if(item.COLUMN_NAME === 'LIC_BEGIN_DATE'){
          defaultVal = "2024-03-08"
        }
        dataOne[item.COLUMN_NAME] = defaultVal;
      })
      this.addTableDataList.push(dataOne);
      console.log(this.addTableDataList)
    },
    //点击删除按钮（数据录入功能）
    deleteTableData() {
      this.addTableDataList.pop();
    },
    resetTableData() {
      this.addTableDataList = [];
    },
    //点击提交按钮（数据录入功能）
    submitTableData() {
      console.log(this.addTableDataList);
      if (this.addTableDataList.length==0){
        ElMessage.info("请添加数据！");
        return;
      }
      let now = new Date();
      let y = now.getFullYear();
      let m = now.getMonth()+1;
      let d = now.getDate();
      let h = now.getHours();
      let mi = now.getMinutes();
      let s = now.getSeconds();
      m = m>9?m:"0"+m;
      d = d>9?d:"0"+d;
      h = h>9?h:"0"+h;
      mi = mi>9?mi:"0"+mi;
      s = s>9?s:"0"+s;
      now = y+"-"+m+"-"+d+"|"+h+":"+mi+":"+s;
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/record/add";
      let token = localStorage.getItem("lyqtJwt");
      let data = {};
      data.pageId = this.templateInfo.pageid;
      data.pageName = this.templateInfo.modulename;
      data.dataUrl = this.form.dataSource;
      data.header = this.theHeader;
      data.data = this.addTableDataList;
      data.authorization = token;
      data.uploadType="录入数据";
      data.uploadTime = now;
      console.log("data:",data)
      console.log("form:",this.form)
      axios.post(url, data).then(res => {
        console.log(res)
        ElMessage.success(res.data.msg);
        if (res.data.success){
          this.addTableDataList=[];//清空添加数据列表
          this.viewTableControl=true;//显示查询数据报表
          this.initGrid();//刷新数据
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    //判断字段录入类型
    entryType() {
      //措施井页面定制化处理   通用录入功能
      if(this.$route.name === '6-1') {
        this.theHeader.forEach(item => {
          if (item.label == "产品名称" || item.label == "产品版本" || item.label == "许可类型" || item.label == "客户归属单位")
            item.entryType = "select";
          else if (item.label == "许可起效日期")
            item.entryType = "date";
          else {
            item.entryType = "input";
            if (item.DATA_TYPE == 'NUMBER')
              item.entryType = "number";
            if (item.DATA_TYPE == "DATE")
              item.entryType = "date";
          }
        })
      }
      else if(this.templateInfo.type == "table_enter_csj"){
        this.theHeader.forEach(item => {
          // if (item.label == "井别" || item.label == "油气管理区" || item.label == "油气田" || item.label == "区块单元" || item.label == "层位" )
          //   item.entryType = "text";
          // else
          if (item.label == "拼音井名" || item.label == "措施大类" )
            item.entryType = "select";
          else if (item.label == "开工日期" || item.label == "开井日期")
            item.entryType = "date";
          else
            item.entryType = "input";
        })
      }
      else {
        this.theHeader.forEach(item => {
          item.entryType = "input";
          if (item.DATA_TYPE == 'NUMBER')
            item.entryType = "number";
          if (item.DATA_TYPE == "DATE")
            item.entryType = "date";
        })
      }
    },
    // showModeChange(){
    //   this.$refs.tableControl.showRouteIn = !this.showDocView
    // },
    handleInput(event, item, index) {
      const value = parseFloat(event); // 将输入转换为浮点数
      if (!isNaN(value)) {
        // 如果有最大值限制且输入超过最大值，将值设置为最大值
        console.log(item,item.data,this.maxInputNumber)
        switch(item.data){
          case "LIC_COUNT":
            this.minInputNumber = this.licConfig.licCountMin;
            this.maxInputNumber = this.licConfig.licCountMax;
            break;
          case "LIC_ENABLE_DAYS":
            this.minInputNumber = this.licConfig.licDaysMin;
            this.maxInputNumber = this.licConfig.licDaysMax;
            break;
        }
        if (value > this.maxInputNumber) {
          this.addTableDataList[index][item.data] = this.maxInputNumber;
        }
        else if(value < this.minInputNumber) {
          this.addTableDataList[index][item.data] = this.minInputNumber;
        }
      }
    },
    //下拉框获取焦点时触发（数据录入功能）
    getSelectFocus(label, index) {
      console.log(label, index);
      this.selectDataList = [];
      if (label == "拼音井名") {
        let wellGroupData = this.$store.state.wellgroupData;
        if (wellGroupData.length == 0)
          return
        wellGroupData[0].children.forEach(item => {
          if ('children' in item) {
            item.children.forEach(ite => {
              this.selectDataList.push(ite.label);
            })
          }

        })
      }
      if (label == "措施大类") {
        //未确定井别时不添加下拉框数据
        if (this.addTableDataList[index].YPLX == "")
          return;
        console.log(this.cslxSelectObj);
        this.selectDataList = this.cslxSelectObj[this.addTableDataList[index].jblx][0];

        // //获取措施类型数据
        // axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getTorStat?yplx="+this.addTableDataList[index].YPLX).then(res=>{
        //   console.log(res)
        //   res.data.content[0].forEach(item=>{
        //     let data={};
        //     data.label=item;
        //     this.selectDataList.push(data);
        //   })
        // }).catch(err=>{
        //   console.log(err);
        // })
      }
      if (label == "措施子类") {
        //未确定措施大类时不添加下拉框数据
        if (this.addTableDataList[index].CSDL == "")
          return;
        this.selectDataList = this.cslxSelectObj[this.addTableDataList[index].jblx][1][this.addTableDataList[index].CSDL]
      }
      switch (label) {
        case "产品名称":
          this.selectDataList = this.licProducts.productList;
          break;
        case "产品版本":
          console.log("row",this.addTableDataList[index])
          this.selectDataList = this.licProductVersionMap.productVersionAssocMap[this.addTableDataList[index].GPT_PRODUCT_NAME];
          break;
        case "许可类型":
          this.selectDataList = this.licClass.modeList;
          break;
        case "客户归属单位":
          this.selectDataList = this.licCustomUnit.unitList;
          break;
      }
    },
    //下拉框选值发生变化时触发
    enterSelectChange(label, value, index) {
      console.log(label, value, index);
      if (label == "拼音井名") {
        //获取措施类型数据
        axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getWellRelatedData?well=" + value).then(res => {
          console.log(res);
          if (res.data.success) {
            this.addTableDataList[index].YPLX = res.data.content[0].YPLX;
            this.addTableDataList[index].KFB = res.data.content[0].KFB;
            this.addTableDataList[index].YT = res.data.content[0].YT;
            this.addTableDataList[index].QK = res.data.content[0].QK;
            this.addTableDataList[index].COMPLETION_NAME = res.data.content[0].COMPLETION_NAME;
            //根据获取的井别添加对应标识
            this.addTableDataList[index].jblx = "PROD";
            if (this.addTableDataList[index].YPLX == null || this.addTableDataList[index].YPLX.indexOf("注") != -1)
              this.addTableDataList[index].jblx = "INJ";
          }
        }).catch(err => {
          console.log(err);
        })
      }
      switch(label) {
        case "产品名称":
          break;
      }
    },
    //无限滚动事件
    infiniteScroll(){
      let len=this.form.data.length;
      let page=len / 99 + 1;

      console.log("总记录数:",this.form.dataNum)
      console.log("页数：",page);

      //显示分页时，不允许进入
      if(this.form.pagination)
        return;
      //数据加载中，不允许进入
      if(this.isInfinite)
        return;
      //判断无限滚动的最后一页数据，提示并退出
      if (this.pageSize==99 && Math.ceil(page-1)*99>=this.form.dataNum){
        ElMessage.info("已加载全部数据");
        return;
      } //判断无限滚动的最后一页数据，提示并退出
      if (this.pageSize==99999999){
        ElMessage.info("已加载全部数据");
        return;
      }
      //非滚动到底触发的情况，不允许进入
      if(Math.floor(page) != page)
        return

      this.isInfinite = true;//防止同一时间多次触发
      //获取数据
      let drillObj = this.curDrillObj;
      console.log("queryGridDrill", drillObj);
      let that = this;
      if (drillObj != undefined) {
        if (drillObj.type == "1") {
          let drillid = ""
          for (let i = 0; i < drillObj.value.length; i++) {
            drillid = drillid + "," + drillObj.value[i].id
          }
          that.drillJH = drillid.substring(1, drillid.length)
          that.drillBlock = "";
        } else if (drillObj.type == "0") {
          let drillQK = ""
          for (let i = 0; i < drillObj.value.length; i++) {
            drillQK = drillQK + "," + drillObj.value[i]
          }
          that.drillBlock = drillQK.substring(1, drillQK.length)
          that.drillJH = "";
        } else {
          that.drillBlock = "";
          that.drillJH = "";
        }
      } else {
        that.drillBlock = "";
        that.drillJH = "";
      }
      this.viewSelectionWell = false;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      let token = localStorage.getItem("lyqtJwt");
      if (userInfoSession == null) userInfoSession = {};
      let curUserEmplyeeId = "";
      let user_name = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
        user_name = jsonUserInfo.displayName;
        user_id = curUserEmplyeeId;
      }
      let queryFilter = [];

      //处理查询语句，选择时间后，将时间条件拼接上
      queryFilter = JSON.parse(JSON.stringify(this.queryFilter));
      if (this.frameQueryFilter != null) {
        if (queryFilter.length != 0) {
          this.frameQueryFilter.logic = "AND";
        }
        queryFilter.push(this.frameQueryFilter);
      }
      let blockQueryFilter=this.$store.state.blockQueryFilter;
      // console.log("shshssssssssssssssssss1",blockQueryFilter)
      if (blockQueryFilter!=[] && blockQueryFilter.length!=0){
        if (queryFilter.length != 0) {
          blockQueryFilter.logic = "AND";
        }
        queryFilter.push(blockQueryFilter);
      }

      let grupOneName = '井组1';
      let grupTwoName = '井组2';
      for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
        if (this.relation_grup_list[grupIdx].value == this.relation_grupone_name) {
          grupOneName = this.relation_grup_list[grupIdx].label;
        }
        if (this.relation_grup_list[grupIdx].value == this.relation_gruptwo_name) {
          grupTwoName = this.relation_grup_list[grupIdx].label;
        }
      }
      console.log("queryFiter:", queryFilter, JSON.stringify(this.relation_grupone_wells), JSON.stringify(this.relation_gruptwo_wells))
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddata", {
        user_id: user_id,
        user_empid: curUserEmplyeeId,
        user_name: user_name,
        dataAddress: this.form.dataAddress,
        app_id: this.templateInfo.pageid,
        checked: this.choseHeader,
        header: this.theHeader,
        blkTypeID: this.curBlkTypeId,
        checkedBlk: this.curCheckedBlkId,
        dataSort: this.form.dataSort,
        drillJH: that.drillJH,
        drillBlock: that.drillBlock,
        token: token,
        queryFilter: queryFilter,//查询条件
        total: true,//是否需要返回总页数
        page: page,//当前页码从1开始
        size: this.pageSize,//一页显示记录数
        wellOne: this.relation_grupone_wells,
        wellTwo: this.relation_gruptwo_wells,
        wellOneName: grupOneName,
        wellTwoName: grupTwoName,
        tableType: this.templateInfo.type,
        decimals:this.form.decimals,
        isDefaultTemplate: this.isDefaultTemplate,
        configName:this.configName,
      }).then(res => {
        console.log("返回数据：", res.data);
        this.useEdit(res.data.data);
        // let oldDat = JSON.parse(JSON.stringify(this.form.data));//复制初始option（未进行绘制拟合曲线）
        // for (let i = 0; i < res.data.data.length; i++) {
        //   oldDat.push(res.data.data[i]);
        // }
        this.form.data = this.form.data.concat(res.data.data);
        this.jsons.data = this.form.data;
        this.isInfinite = false;
      }).catch(err => {
        console.log(err)
      })
    },
    //表格内容是否可编辑初始化
    useEdit(data) {
      data.forEach((item, index) => {
        for (let i in item) {
          data[index][i] = {
            value: data[index][i],
            edit: false
          }
        }
      });
    },

    //双击触发修改配置模板的名称
    dblclickConfigName(item) {
      console.log("配置模板信息：", item);
      //只能修改用户模板名称
      if (this.switchConfigCame.indexOf("（公用）") != -1) {
        return
      }
      item.config_nameOld = item.config_name.toString();//保留旧名称
      item.config_name = item.config_name.replace("（用户）", "");//去除用户标识
      item.isShow = true;
      this.$nextTick(() => {
        this.$refs[item.config_name] && this.$refs[item.config_name].focus(); //聚焦编辑框
      })
    },
    //提交修改配置模板名称
    updateConfigName(item,idx) {
      item.config_name = item.config_name + "（用户）";
      item.isShow = false;
      //未修改时退出
      if (item.config_nameOld == item.config_name)
        return
      //名称重复，退出
      let isRepeatName = false;
      this.configList.forEach((i, index) => {
        let name = i.config_name.replace("（用户）", "").replace("（公用）", "");
        let onName = item.config_name.replace("（用户）", "").replace("（公用）", "");
        //名称重复判定，排除自己
        if (onName == name && idx != index) {
          isRepeatName = true;
        }
      })
      if (isRepeatName){
        ElMessage("模板名称不能重复！");
        item.config_name = item.config_nameOld;
        return;
      }

      //修改名称后，单选选中信息不一致，需更新
      if (item.config_nameOld == this.switchConfigCame) {
        this.switchConfigCame = item.config_name;
      }
      //当修改当前选择模板时，修改选中信息
      if (item.config_nameOld == this.configName) {
        this.switchConfigCame = item.config_name;
        this.configName = item.config_name;
      }
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/updatecConfigName",
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          item: item,
          type:"table"
        }
      }).then(res => {
        console.log(res);
        ElMessage.success(res.data.message)
      }).catch(err => {
        console.log(err);
      })
    },
    //获取多级表头
    getManyHeader(header){
      if (this.templateInfo.moduleid=="---"){
        this.isManyHeader=true;
        let manyHeaderObj={};
        for(let i=0;i<header.length;i++){
          let id="";
          let name="";
          let headerChid={};
          if (header[i].label=="油气管理区"){
            id="aa";
            name="";
          }
          if (header[i].label=="油田"){
            id="ab";
            name="";
          }
          if (header[i].data=="SJ_KFDY"){
            id="ac";
            name="开发单元";
            header[i].label="实际";
          }
          if (header[i].data=="JH_KFDY"){
            id="ac";
            name="开发单元";
            header[i].label="计划";
          }
          if (header[i].label=="油品及岩性"){
            id="ad";
            name="一级表头";
          }
          if (header[i].label=="变更日期"){
            id="ad";
            name="一级表头";
          }
          if(manyHeaderObj[id]==undefined){
            headerChid.id=id;
            headerChid.name=name;
            headerChid.children=[]
            manyHeaderObj[id]=headerChid;
          }
          manyHeaderObj[id].children.push(header[i]);
        }
        console.log("多级表头")
        console.log(manyHeaderObj)
        let manyHeader=[];
        for (let item in manyHeaderObj){
          manyHeader.push(manyHeaderObj[item]);
        }
        console.log(manyHeader)
        this.manyHeader = manyHeader;
      }
    }
  },
  watch: {
    iswellGroup: {
      handler() {
        console.log("wellGrp:",this.iswellGroup);
      }
    },
    templateInfo: {
      handler(oldVal,newVal) {
        console.log("watchframeTime:",this.frameTime,oldVal != newVal,this.$store.state.isWarDriing);
        if(oldVal != newVal) {
          this.curDrillObj =  this.$store.state.drillObj == undefined?undefined:JSON.parse(JSON.stringify(this.$store.state.drillObj));
          if(this.templateInfo.type!=null && this.templateInfo.type.indexOf('table_day')!=-1){
            this.frameTime = [this.getNowDate(2,30),this.getNowDate(2,0)]
          }
          else if (this.templateInfo.type!=null && (this.templateInfo.type.indexOf('table_mon')!=-1 || this.templateInfo.type.indexOf('table_enter_csj')!=-1)){
            this.frameTime = [this.getNowDate(1,13),this.getNowDate(1,1)];
          }

          this.initGrid();
          this.judgePageType();
        }
        this.blockSelectShow=true;
        console.log("watch结束")
      },
      deep: true,
    },
    "$store.getters.getWellData":{
      handler(oldVal,newVal){
        console.log("===================================")
        console.log("$store.getters.getWellData")
        console.log(this.$store.getters.getWellData)
        if(oldVal != newVal){
          this.wellDataClickNum = 0;
          if(this.pageSize == 99999999){
            this.pageSize = 99;
          }
          this.wellDataClick()
        }
      }
    },
    "$store.state.drillObj":{
      handler(oldVal,newVal) {
        if(oldVal != newVal){
          if(this.pageSize == 99999999){
            this.pageSize = 99;
          }
          if(this.noRefreshDrillObj){
            this.noRefreshDrillObj = false;
            return;
          }
          this.$nextTick(()=>{
            if(this.$store.state.drillObj != undefined) {
              if (this.$store.state.isJump && this.$store.state.gisJumpRoute == this.$route.name) {
                this.curDrillObj = this.$store.state.drillObj == undefined ? undefined : JSON.parse(JSON.stringify(this.$store.state.drillObj));
                if (this.$store.state.isDriing == 0) {
                  this.$store.state.drillObj = undefined;
                }
                this.initGrid();
                console.log(oldVal, newVal)
                console.log("走了吗drillObj!", this.$store.state.drillObj)
                console.log("BB", this.$route.name)
              }
              else if(this.$store.state.isJump == false){
                this.curDrillObj = this.$store.state.drillObj == undefined ? undefined : JSON.parse(JSON.stringify(this.$store.state.drillObj));
                if (this.$store.state.isDriing == 0) {
                  this.$store.state.drillObj = undefined;
                }
                if(this.curDrillObj != undefined){
                  if(this.curDrillObj.type === 1 && this.curDrillObj.value != null && this.curDrillObj.value.length>0){
                    if(this.$refs.blkSel.isShow.well){
                      this.$refs.blkSel.well = this.curDrillObj.value[0].text;
                    }
                  }
                }
                this.initGrid();
                console.log(oldVal, newVal)
                console.log("走了吗drillObj!", this.$store.state.drillObj,this.curDrillObj)
              }
            }
          })
        }
      },
      deep: true,
    },
    "$store.state.warningReadData":{
      handler(oldVal,newVal){
        console.log("===================================")
        console.log("$store.state.warningReadData")
        console.log(this.$store.state.warningReadData)
        if(oldVal != newVal){
          if(this.$store.state.isWarDriing == 1){
            // this.$store.state.isWarDriing = 0;
            let drillObj = {};
            if(this.$store.state.warningReadData.compareDate != undefined && this.$store.state.warningReadData.compareDate.length!=0){
              if(this.$store.state.warningReadData.compareDate == "前一天") {
                if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
                  let startTime = this.getNowDate(2, 2);
                  let endTime = this.getNowDate(2, 1);
                  this.frameTime = [startTime, endTime];
                  console.log(this.frameTime)
                }
              }
              else if(this.$store.state.warningReadData.compareDate.indexOf("前")>=0){
                //前N天
                let nNum = this.$store.state.warningReadData.compareDate;
                nNum = parseInt(nNum.replace("前","").replace("天",""));
                if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
                  let startTime = this.getNowDate(2, nNum+1);
                  let endTime = this.getNowDate(2, 1);
                  this.frameTime = [startTime, endTime];
                  console.log(this.frameTime)
                }
              }
              else{
                //指定日期 xxxx-xx-xx
                if (this.templateInfo.type != null && this.templateInfo.type.indexOf('table_day') != -1) {
                  let startTime = this.$store.state.warningReadData.compareDate;
                  let endTime = this.getNowDate(2, 1);
                  this.frameTime = [startTime, endTime];
                  console.log(this.frameTime)
                }
              }
            }
            if(this.$store.state.warningReadData.JH != undefined && this.$store.state.warningReadData.JH.length!=0){
              drillObj.type = 1;
              drillObj.value = [{id:this.$store.state.warningReadData.JH,
                text:this.$store.state.warningReadData.JH}];
              this.$store.state.isJump = false;
              this.$store.state.drillObj =drillObj;
            }
            console.log("走了吗warningList!",this.$store.state.warningReadData)
          }
        }
      }
    },
    switchConfigCame:{
      handler(){
        console.log(this.switchConfigCame)
      }
    },
    drillValue: {
      handler() {
        if (this.drillValue.router == undefined || this.drillValue.router == "") {
          this.routerText = "空"
        }

      },
      deep: true,
      immediate: true
    },
    refreshDialogVisible(){
      console.log(this.refreshDialogVisible)
      if(this.refreshDialogVisible){
        this.$nextTick(()=>{
          this.$refs.queryConfig.num1=this.queryConfigNum.num1;
          this.$refs.queryConfig.num2=this.queryConfigNum.num2;
        })
      }
    },
    //监听获取时间数据
    frameTime() {
      if (this.frameTime) {
        console.log("frameTimeWatch:",this.frameTime[0], this.frameTime[1]);
        this.$store.state.frameTime= this.frameTime;//保留时间

        //页面初始化加载时间，给时间范围选择器赋值
        if (this.isYear || this.isYearMonth || this.isYearMonDay || (this.templateInfo.type!= undefined && (this.templateInfo.type == 'table_mon' || this.templateInfo.type == 'table_year'
            || this.templateInfo.type == 'table_day' || this.templateInfo.type.indexOf('table_enter_csj')!=-1))) {
          this.frameYear.startTime = this.frameTime[0];
          this.frameYear.endTime = this.frameTime[1];
        }
      }
    },
    //监听范围时间数据（年度）
    frameYear:{
      handler(){
        console.log(this.frameYear);
        //初始化加载数据时给时间赋值，防止二次执行
        if (this.theHeader.length==0)
          return
        //选择时间段后触发，将时间数据赋值给frameTime变量，调用处理函数
        if (this.frameYear.startTime!=null && this.frameYear.endTime!=null){
          let time=[];
          time.push(this.frameYear.startTime);
          time.push(this.frameYear.endTime);
          this.frameTime=time;
          // this.selectTime();
        }
      },
      deep:true
    },
    currentPage(){
      this.$refs.tableControl.ViewCurrentPage = this.currentPage;
    },
    pageSize(){
      this.$refs.tableControl.ViewpageSize = this.pageSize;
    },
    //监听使用时间类型
    frameTimeType(){
      //切换时间类型时，将时间段的后一个日期赋值给时间点
      if (this.frameTimeType && this.frameTime != null && this.frameTime.length > 0)
        this.frameTimeSpot = this.frameTime[1];
      // //时间段，时间点都为空则不刷新数据
      // if (this.frameTime != null || this.frameTimeSpot != null)
      //   this.selectTime();
    },
  }
}

</script>

<style scoped>
.paginationClass {
  float: right;
}
.block{
  /*margin-top: 10px;*/
  margin-left: auto;
}
/*考核——新增弹出框样式*/
.fromItem>.el-form-item{
  padding-bottom: 25px;
}
</style>

<style scoped>
/*/deep/.el-table th {*/
/*  overflow: hidden;*/
/*  -webkit-user-select: none;*/
/*  -moz-user-select: none;*/
/*  user-select: none;*/
/*  background: #e5f9f9;*/
/*  color: #545c64;*/
/*  border: 1px solid lightgray;*/
/*  font-size: 14px;*/
/*  text-align: center;*/
/*}*/
/deep/.el-table--border td{
  border: 1px solid #e5e5e5;
}
/*/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {*/
/*  background: #e6f0f9;*/
/*}*/
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  /*background-color: #F5F7FA;*/
/*background-color: #fffadf;*/
background-color: #ffffff;
border: 1px solid #fffacf;
}
/deep/.el-divider__text {
position: absolute;
background-color: #FFF;
padding: 0 20px;
color: #303133;
font-size: 20px;
font-weight: bold;
}
/deep/.el-table__header tr,
/deep/.el-table__header th {
padding: 0;
height: 35px;
}
/deep/.el-table__body tr,
/deep/.el-table__body td {
padding: 0;
height: 25px;
}
/deep/.newChartBtn{
margin-bottom: 0px;
}
/deep/.paperview-input-text > .el-input__inner {
-webkit-appearance: none;
background-color: #FFF;
background-image: none;
border-radius: 4px;
border: 0px;
width: 100%;
}
</style>
